/*    
 *  _________________________________________
 * / Stop right there, ya dingus. This file  \
 * \ should not be edited.                   /
 *  -----------------------------------------
 *  \
 *   \
 *      __
 *     /  \
 *     |  |
 *     @  @
 *     |  |
 *     || |/
 *     || ||
 *     |\_/|
 *     \___/
 *    
 * This file is automatically generated through https://localise.biz.
 *                                                                         
 * To update this file:
 *
 *  $ npm run update-language
 *
 * Last update:    Mon Jul 27 2026 16:07:58 GMT+0200 (Central European Summer Time)
 * Language keys:  13
 * Language code:  nl
 *
 */

const language = {
  "resources": {
    "alarms": {
      "name": "Alarm |||| Alarmen",
      "create_title": "Maak alarm",
      "text": {
        "alarm_creator": "Wie of wat maakt het alarm",
        "alarm_creator_explanation": "Selecteer wie of wat het alarm maakt. De positie, groepen, en opvolging van dit object of persoon zal gebruikt worden tijdens het alarm.",
        "alarm_information": "Informatie bij het alarm",
        "alarm_information_explanation": "De onderstaande informatie is belangrijk om te bepalen wat er moet gebeuren bij dit alarm. Kies een korte en duidelijke naam (bijv. 'Paniekalarm') en selecteer de urgentie.",
        "severity_options": {
          "red": "Rood (dringend)",
          "orange": "Oranje (aandacht vereist)",
          "green": "Groen (niet dringend)"
        },
        "type_options": {
          "panic": "Paniek",
          "assistance": "Assistentie",
          "test": "Test",
          "outage": "Storing",
          "fire": "Brand",
          "medical": "Medisch",
          "mandown": "Mandown",
          "other": "Anders"
        },
        "procedure_placeholder": "Deze procedure is zichtbaar in de X-Guard Alarm Manager en X-Guard Alarm-app.\n\nBeschrijf wat mensen die komen helpen moeten doen.",
        "ack_definition": "Vereis afmelden",
        "ack_explanation": "Standaard moet een alarm worden afgemeld. Met alarmen die niet afgemeld zijn kan interactie plaatsvinden via de X-Guard Alarm Manager en X-Guard Alarm-app.",
        "ack": {
          "no_time": "Geen tijd",
          "open_alarm": "Open alarm",
          "not_needed": "Niet nodig",
          "acked": "Afgemeld alarm",
          "value": "Vereis afmelden (aangeraden)"
        },
        "page_info": "Deze pagina toont een snel overzicht van alarmen in uw organisatie. Voor meer details over de alarmen opent u de X-Guard Alarm Manager.",
        "acknowledge_all": "Sluit alle",
        "acknowledge_confirmation": "Weet u zeker dat u %{length} alarmen wilt sluiten?",
        "acknowledge_selected": "Sluit geselecteerde",
        "acknowledge": "Sluit",
        "bhvk": {
          "create_title": "Alarm maken",
          "create_subtitle": "Maak een demo-alarm door op de knop aan de linkerkant te klikken. Na het klikken wordt u gecontacteerd via de app of een telefoontje"
        },
        "how_to_receive_title": "Hoe wilt u de alarmen ontvangen?",
        "how_to_receive_subtitle": "Als de app geïnstalleerd is zal het systeem eerst een notificatie sturen naar de app. Als u alleen gebeld wilt worden, verwijder dan de app.",
        "receive_options": {
          "call": "Gebeld worden",
          "app": "Via de app"
        },
        "app_explanation": {
          "1": "1. Installeer de app",
          "2_title": "2. Inloggen in de app",
          "2_2": "Uw gebruikersnaam om in te loggen is: ",
          "2_3": "De app zal u verdere instructies geven om verder te gaan.",
          "1_title": "3. Klaar om alarmen te maken",
          "3_2": "Druk op de knop hierboven om een alarm te maken",
          "under_buttons": "De app kan geïnstalleerd worden via de App store of Google Play"
        },
        "bhvk_alarm_created": "Alarm aangemaakt, U zult deze ontvangen via de door u gekozen methode",
        "simulation_result": "De volgende acties worden ondernomen:",
        "no_alarms": "Er zijn geen alarmen gemaakt in de afgelopen 7 dagen.",
        "notified": "Opgeroepen",
        "will_help": "Komt helpen",
        "will_not_help": "Komt niet helpen",
        "nobody_notified": "Niemand, lees hier waarom",
        "view_alarms": "Bekijk alarmen",
        "create_an_alarm": "Maak een alarm",
        "title_subtext": "Op deze pagina vind u een overzicht van alle alarmen.",
        "no_links": "Er zijn geen links ingesteld voor opvolging",
        "no_one_called_for_link": "Op dit moment wordt in dit proces wordt niemand opgeroepen."
      },
      "fields": {
        "name": "Alarm naam",
        "severity": "Urgentie",
        "type": "Alarm type",
        "procedure": "Procedure",
        "ack": {
          "name": "Heeft afmelding nodig",
          "value": "Afgemeld"
        },
        "alarmCenter": {
          "name": "Meldkamer"
        },
        "customer": {
          "_id": "Klant"
        },
        "mergeHistory": "Dubbel aangemaakt"
      }
    },
    "assets": {
      "name": "Asset |||| Assets",
      "text": {
        "annotation": "Deze pagina laat geen app-gebruikers zien",
        "without_app_title": "Assets zonder app",
        "single_name": "Asset",
        "general": "Algemeen",
        "properties": "Eigenschappen",
        "response": "Opvolging",
        "app": "App",
        "app_mode_not_editable": "App modus kan niet aangepast worden",
        "app_available_explanation": "Wanneer beschikbaar op aan staat, kan de gebruiker verzoeken tot helpen ontvangen bij alarmen van gebruikers dichtbij.",
        "download_history_button": "Download geschiedenis",
        "delete_user": "Gebruiker verwijderen",
        "groups_updated": "Groepen bijgewerkt",
        "edit_groups": "Groepen aanpassen",
        "without_app_description": "Assets zijn personen of objecten die niet aan de X-Guard Alarm-app gebonden zijn. U kunt hier assets bekijken en bewerken. Het toevoegen en verwijderen van assets is niet mogelijk omdat deze soms worden gebruikt voor geavanceerde configuraties in uw organisatie. In de meeste gevallen wenst u een [gebruiker](%{adminPath}) of [App-gebruiker](%{appUserPath}) aan te maken i.p.v. een asset.",
        "has_app": "Is app-gebruiker",
        "add_bhv": "BHV'er toevoegen",
        "add_user": "Gebruiker toevoegen",
        "add_user_tooltip": "Na bestelling kunt u gebruikers toevoegen",
        "add_bhv_tooltip": "Na bestelling kunt u BHV'ers toevoegen",
        "bhvk_deleted": "Gebruiker verwijderd",
        "number_of_available_users": "Totaal aantal gebruikers die alarmen kunnen ontvangen",
        "number_of_expiring_certifications": "Totaal aantal verlopende certificaten",
        "number_of_expired_certifications": "Totaal aantal verlopen certificaten"
      },
      "fields": {
        "user": {
          "_id": "Gebruiker"
        },
        "externalId": "Extern ID",
        "description": "Beschrijving",
        "phoneNumber": "Telefoonnummer",
        "smsNumber": "SMS nummer",
        "email": "Email",
        "image": "Afbeelding",
        "available": "Beschikbaar",
        "staticResponders": {
          "name": "Statische helpers",
          "staticResponder": "Statische helper",
          "priority": "Prioriteit"
        },
        "position": {
          "provider": "Positite is statisch "
        },
        "invisibleResponder": "Is onzichtbare helper",
        "allowContactOnOwnAlarms": "Sta contact toe bij eigen alarm (Laat telefoonnummer zien in Alarm manager)",
        "lastObservationAt": "Laatste observatie op",
        "insideZones": "Binnen zones",
        "can_receive": "Alarmoproepen ontvangen",
        "my_security": "Eigen beveiliging",
        "last_active_at": "Laatst actief op",
        "has_app": "Gebruikt de app"
      },
      "download_history_for_last": "Download geschiedenis voor de laatste:",
      "certifications": {
        "fields": {
          "documentary_proof": "Documentair bewijs",
          "first_issued_on": "Eerste uitgave op",
          "last_received_on": "Verlengd op",
          "expiry_date": "Vervaldatum",
          "planned_renewal_date": "Geplande verlenging"
        },
        "text": {
          "add_certification": "Certificaat toevoegen",
          "sub_title": "Certificaten",
          "not_provided": "Niet verstrekt",
          "not_required": "Niet vereist",
          "not_required_description": "Voor deze certificeringscategorie is geen bewijsdocument vereist.",
          "title_single": "Certificaat",
          "certification_deleted": "Certificaat verwijderd",
          "expiry_date_input_helper_text": "De vervaldatum is standaard ingevuld op basis van de laatst ontvangen datum plus de geldigheidsperiode van de certificeringscategorie. U kunt deze indien nodig handmatig wijzigen.",
          "view_document": "Bekijk document",
          "drop_document_to_upload": "Sleep het document hierheen om het te uploaden of klik om het te selecteren.",
          "edit_certification_title": "Bewerk het %{category}-certificaat voor %{user_name}",
          "renew": "Verlengen",
          "renew_now_modal_title": "Nu verlengen",
          "renew_now_modal_helper_text": "De vervaldatum wordt vooringevuld op basis van de laatst ontvangen datum plus de geldigheidsperiode van de certificeringscategorie. U kunt deze indien nodig handmatig aanpassen.",
          "plan_renewal_modal_title": "Verlenging plannen",
          "renew_bulk": "Certificaten verlengen",
          "assign_document_to_user": "Toewijzen aan gebruiker",
          "bulk_assign_documents_helper": "Wijs elk geüpload document toe aan de bijbehorende gebruiker.",
          "reset_document_assignments": "Toewijzingen opnieuw instellen",
          "bulk_documents_count_mismatch": "Het aantal geüploade documenten moet overeenkomen met het aantal geselecteerde gebruikers.",
          "bulk_documents_assignment_incomplete": "Wijs elk document toe aan een unieke gebruiker. Elke geselecteerde gebruiker moet precies één document ontvangen.",
          "drop_documents_to_upload": "Sleep documenten hierheen om te uploaden of klik om ze te selecteren",
          "bulk_upload_documents_helper": "Upload het bewijsmateriaal voor de geselecteerde gebruiker. |||| Upload %{smart_count} bewijsstukken voor de geselecteerde gebruikers.",
          "select_categories": "Selecteer certificeringscategorie",
          "preview_file": "Bestand bekijken",
          "select_user": "Selecteer gebruiker",
          "select_category": "Selecteer categorie",
          "planned_renewal_date_helper_text": "E-mailmeldingen worden uitgesteld tot de geplande verlengingsdatum.",
          "missing_documentary_proof": "ontbrekend bewijsmateriaal",
          "category_tooltip": "%{name} - %{expiry}",
          "category_tooltip_with_missing_proof": "%{name} - %{missing_proof}, %{expiry}",
          "planned_renewal_in_tooltip": "geplande verlenging %{date}",
          "renew_now": "Certificaat al verlengd",
          "plan_renewal_subtitle": "Plan wanneer de geselecteerde certificaten verlengd moeten worden",
          "renew_now_subtitle": "Stel nieuwe verlengings- en vervaldatums in voor de geselecteerde certificaten",
          "choice_dialog_subtitle": "Hoe wilt u de geselecteerde certificaten bijwerken?",
          "choice_dialog_title": "Verlenging beheren",
          "plan_renewal": "Certificaat wordt in de toekomst verlengd",
          "apply_dates_to_all": "Toepassen op alles",
          "no_preview": "Geen voorbeeld",
          "no_common_category_tooltip": "Deze gebruiker heeft geen gemeenschappelijke certificaten met de geselecteerde gebruikers",
          "no_common_certificates": "Geselecteerde gebruikers hebben geen gemeenschappelijke certificaten",
          "selected_user_no_certificates": "Geselecteerde gebruiker heeft geen certificaten"
        },
        "validation": {
          "expiry_date_must_be_future": "De vervaldatum moet in de toekomst liggen."
        }
      }
    },
    "app-users": {
      "text": {
        "sent_configuration": "Configuratie verstuurd naar apparaat",
        "sent_configuration_failed": "Configuratie versturen naar apparaat mislukt",
        "sent_log": "Aanvraag voor log verstuurd naar apparaat",
        "sent_log_failed": "Aanvraag voor log versturen naar apparaat mislukt",
        "actions": "Acties",
        "send_critical_title": "Verstuur als kritisch ",
        "send_critical_explanation": "Deze schakelaar geeft aan of de notificatie als kritisch verstuurd moet worden. Zet de schakelaar naar de gewenste waarde voordat er op de knop\ngedrukt wordt om de notificatie te verzenden. ",
        "configuration_update_title": "Configuratie update",
        "configuration_notification_title": "Verstuur configuratie notificatie",
        "configuration_notification_explanation": "Dit verstuurt een notificatie naar het apparaat met daarin de vraag om op de notificatie te klikken. Als dit gedaan wordt, wordt de configuratie direct herladen",
        "log_notification_title": "Vraag apparaat log op",
        "log_notification_explanation": "Dit verstuurt een notificatie naar het apparaat met daarin de vraag om op de notificatie te klikken. Als dit gedaan wordt, stuurt het apparaat een log naar het ontwikkel-team",
        "device_info": "Apparaatinformatie",
        "installed_version": "Geinstalleerde versie",
        "available_version": "Beschikbare versie",
        "compliance_state": "Beleidstatus",
        "compliance_true": "Synchroon met beleid",
        "compliance_false": "Niet syncroon met beleid",
        "device_profile": "Apparaatprofiel",
        "permissions": "Permissies (Alleen voor de huidige OS)",
        "saving_group_successful": "Groepen succesvol opgeslagen",
        "saving_group_failed": "Groepen opslaan mislukt",
        "config": "Configuratie",
        "group_title": "Groepen",
        "group_explanation": "Als twee groepen dezelfde configuaties aanpassen, dan overschrijft de laaste groep veranderingen uit eerdere groepen. Zorg ervoor dat de groep-volgorde correct is",
        "last_sync": "Laatste syncronisatie",
        "last_config_update": "Laatste configuratie update",
        "last_config_compliance": "Laatste configuratie is syncroon met beleid",
        "reset_groups": "Reset groepen",
        "save_groups": "Groepen opslaan",
        "no_valid_config": "Deze gebruiker heeft geen geldige apparaat configuratie en kan niet gewijzigd worden",
        "download_group": "Groep? Laat leeg om geen groep toe te voegen.",
        "view_device_json": "Ga naar de console om de apparaat JSON te zien",
        "configuration": "Configuratie",
        "show_unmodified_keys": "Laat onveranderde sleutels zien",
        "delete_success": "App-gebruikers verwijderd",
        "delete_success_single": "App-gebruiker verwijderd",
        "delete_failed": "App-gebruikers verwijderen mislukt",
        "delete_failed_single": "App-gebruiker verwijderen mislukt",
        "delete_title": "Verwijder App-gebruikers",
        "delete_all_devices": "Verwijder alle apparaten",
        "updated": "App-gebruikers bijgewerkt",
        "title": "App-gebruikers",
        "created": "App-gebruiker aangemaakt! De gebruiker kan nu inloggen met %{username} via de X-Guard Alarm-app",
        "create_explanation": "Voor registratie, open de X-Guard Alarm app en scan de organisatie QR Code",
        "page_info": "App-gebruikers hebben de mogelijkheid om in te loggen op de X-Guard Alarm-app. App-gebruikers kunnen niet inloggen op de dashboards.",
        "group_and_config_button_title": "Groepen en configuratie",
        "config_and_groups_updated": "Groepen en configuratie bijgewerkt!",
        "fill_phonenumber": "Voer eerst een telefoonnummer in",
        "available_helper": "Als 'Ontvangt alarmen' is ingeschakeld, ontvangt dit account actief in aanmerking komende alarmen. Dit gebeurt via een telefoontje of, indien ingelogd, via de app.",
        "warning_sends_email": "Let op: dit registratieprofiel verstuurd een e-mail naar de nieuwe gebruiker",
        "create_continue": "Hoe wilt u doorgaan?",
        "create_modal_intro": "App-gebruikers kunnen op twee manieren worden geregistreerd. Dit kunt u de gebruiker zelf laten doen door bij het openen van de app een QR-code te scannen, of u kunt de gebruiker zelf aanmaken.",
        "create_modal_open_qrcodes": "QR-codes openen",
        "create_modal_manually_create_user": "Handmatig aanmaken",
        "devlog_notification_title": "Vraag apparaat dev log op",
        "go_to_connected_users": "Ga naar gekoppelde gebruiker",
        "ios_config_warning": "Deze groep bevat keys die niet werken op iOS. De niet-werkende keys hebben betrekking op schema's. Andere keys in deze groep werken nog wel.",
        "include_button_count": "Aantal Flic-knoppen",
        "device_logs_title": "Apparaatlogs",
        "device_logs_open_uploads": "Bekijk geuploade apparaatlogs",
        "device_logs_open_uploads_explanation": "Selecteer een of meerdere geuploade apparaatlogs en laad ze via de Report API.",
        "device_logs_uploads_modal_title": "Apparaatlog uploads",
        "device_logs_connected_device": "Verbonden apparaat: %{deviceId}",
        "device_logs_upload_fetch_failed": "Laden van apparaatlog uploads mislukt.",
        "device_logs_no_connected_device": "Geen verbonden apparaat gevonden voor deze app-user.",
        "device_logs_uploads_empty": "Geen apparaatlog uploads gevonden voor dit verbonden apparaat.",
        "device_logs_upload_created_at": "Aangemaakt op",
        "device_logs_upload_start_date": "Startdatum",
        "device_logs_upload_end_date": "Einddatum",
        "device_logs_upload_count": "Aantal logs",
        "device_logs_continue": "Doorgaan",
        "device_logs_result_modal_title": "Apparaatlogs",
        "device_logs_group_label": "Upload %{uploadId}",
        "device_logs_fetch_failed": "Laden van geselecteerde apparaatlogs mislukt.",
        "device_logs_fetch_group_failed": "Laden van logs voor deze upload mislukt.",
        "device_logs_upload_severity_counts": "Prioriteit tellingen",
        "device_logs_download": "Logs downloaden",
        "device_logs_severity_filter": "Prioriteit",
        "device_logs_severity_filter_all": "Alle",
        "device_logs_show_ctx": "Context tonen"
      },
      "copy_device_json": "Kopieer apparaat JSON",
      "text_create_register_via_qr": "Gebruiker moet zichzelf registreren via de QR-code",
      "text_create_continue_to_create": "Ik zal de App-gebruiker handmatig aanmaken"
    },
    "asset-groups": {
      "fields": {
        "description": "Beschrijving",
        "asset_count": "Aantal personen",
        "assets": "Assets",
        "bhvk_count": "Aantal leden",
        "bhvk_count_button": "Toon %{length} knoppen of personen"
      },
      "text": {
        "title": "Asset groepen",
        "title_single": "Groep",
        "page_info": "Groepen worden op de achtergrond gebruikt om het gedrag bij het maken en/of opvolgen van een alarm aan te passen.\n\nControleer via deze pagina of de groepen zijn ingesteld zoals verwacht.",
        "no_assets": "Geen personen of objecten",
        "create_title": "Maak nieuwe groep",
        "create_explanation": "Groepen geven u de mogelijkheid om bepaalde gebruikers van elkaar te scheiden. X-Guard kan verschillende configuraties voor de app en alarmopvolging koppelen aan een groep.",
        "add_person": "Persoon toevoegen",
        "delete_warning": "Deze groep wordt gebruikt in de configuratie voor alarm-afhandeling of op een kiosk.",
        "delete_warning_multiple": "Een of meerdere van de geselecteerde groepen worden gebruikt om te configureren hoe alarmen worden afgehandeld.",
        "delete_confirmation": "Ik begrijp dat als ik door ga, de alarmprocedure mogelijk breekt. Ik verwijder deze groep niet tenzij ik zeker weet dat de opvolging nog steeds op orde is."
      },
      "name": "Groepen"
    },
    "beacons": {
      "text": {
        "share_types": {
          "public": "Publiek",
          "default": "Standaard"
        },
        "code": "Code",
        "title": "Bakens",
        "low_battery": "Batterij van baken (bijna) leeg",
        "beacon_last_seen": "Baken niet gezien in de laatste tijd",
        "beacon_healthy": "Baken gezond",
        "in_last_hour": "Binnen het laatste uur"
      },
      "fields": {
        "codes": "Codes",
        "rssiAddend": "RSSI versterking",
        "zone": {
          "_id": "Zone"
        },
        "state": {
          "lastSeenAt": "Laatst gezien op"
        },
        "share": {
          "type": "Deling type"
        },
        "beacon_code": "Baken code"
      }
    },
    "customer-links": {
      "fields": {
        "groups": "Groepen",
        "alarmLevels": "Alarm niveaus",
        "processTemplate": {
          "id": "Proces sjabloon"
        },
        "level": {
          "green": "Groen",
          "orange": "Oranje",
          "red": "Rood",
          "mandown": "Mandown"
        },
        "groupType": "Groep type"
      },
      "text": {
        "title": "Klant connecties",
        "group_types": {
          "all": "Alle groepen",
          "none": "Geen groepen",
          "some": "Sommige groepen",
          "not_in": "Niet in specifieke groepen"
        },
        "types_placeholder": "Als er geen types geselecteerd zijn is de link actief voor alle types"
      }
    },
    "process-templates": {
      "text": {
        "no_asset_error": "Geen asset geselecteerd",
        "simulation_error": "Error in simulatie",
        "previous_stage_delay": "Vertraging vanaf vorige stap: %{delay} seconden",
        "query_speed": "Query snelheid",
        "alarmcenter_escalate": "Escaleer",
        "alarmcenter_queue_name": "Wachtrij naam",
        "no_results_in_stage": "Geen resultaten in deze stap",
        "kilometers": "kilometer",
        "asset_distance": "Afstand",
        "simulate_process": "Simuleer ATS proces",
        "simulate": "Simuleer",
        "simulation_started": "Simulatie gestart",
        "simulation_started_secondary": "ATS is aan het simuleren, even geduld aub",
        "title": "Proces sjablonen",
        "if_script": "if script",
        "taskTemplate": {
          "id": "Taak sjabloon"
        },
        "schedule_tasks": "Taken inplannen",
        "scope_customer": "Klantspecifiek",
        "scope_global": "Globaal",
        "include_global_templates": "Globale sjablonen tonen",
        "global_badge": "Globaal",
        "add_step": "Stap toevoegen",
        "remove_step": "Stap verwijderen",
        "remove_step_confirm": "Weet je zeker dat je deze stap wilt verwijderen?",
        "duplicate_step": "Stap dupliceren",
        "step_number": "Stap %{number}",
        "always_execute": "Altijd uitvoeren",
        "meta_script": "Invoergegevens",
        "xgac_filter": "Assetfilter",
        "request_filters": "Requestfilters",
        "clone": "Klonen",
        "contacted_not_before": "Niet eerder gecontacteerd",
        "asset_id_not_own": "Niet eigen asset-id",
        "asset_id_own": "Eigen asset-id",
        "custom_filter_key": "Selecteer of typ een filtersleutel",
        "filters": "Filters",
        "add_filter": "Filter toevoegen",
        "invalid_filter_key": "Deze filtersleutel wordt niet ondersteund door ATS getAssets",
        "invalid_filter_value": "Ongeldige filterwaarde",
        "max_results": "Max. resultaten (0 voor onbeperkt)",
        "max_unlimited": "Onbeperkt",
        "max_distance_warning": "Waarschuwing: selecteer niet meer dan 10 items bij gebruik van het afstandsfilter. Controleer het simulatieresultaat voordat je doorgaat.",
        "filter_available_yes": "Beschikbaar",
        "filter_available_no": "Niet beschikbaar",
        "comparator_equals": "gelijk aan",
        "comparator_not_equals": "niet gelijk aan",
        "comparator_less_than": "kleiner dan",
        "comparator_less_than_or_equal": "kleiner dan of gelijk aan",
        "comparator_greater_than": "groter dan",
        "comparator_greater_than_or_equal": "groter dan of gelijk aan",
        "same_as_previous_step": "Zelfde als vorige stap",
        "step_not_configured": "Niet geconfigureerd",
        "schedule_tasks_required": "Minimaal één geplande taak is verplicht",
        "meta_data": "Metadata",
        "meta_data_variables": "Variabelen: %{variables}",
        "meta_data_example": "Voorbeeld",
        "any_own_groups": "Eigen groepen",
        "filter_family_groups": "Groep",
        "filter_family_embedded_timestamp": "Laatste observatie",
        "filter_family_id": "Asset-id",
        "filter_family_inside_zones": "In zone",
        "filter_option_contacted": "Gecontacteerd",
        "filter_option_distance": "Afstand (meters)",
        "filter_option_asset_id": "Asset-id",
        "filter_option_customer_id": "Klant-id",
        "comparator_younger": "jonger dan (seconden)",
        "comparator_contains": "bevat",
        "comparator_not_contains": "bevat niet",
        "comparator_older": "ouder dan (seconden)"
      },
      "fields": {
        "processName": "Proces naam",
        "description": "Beschrijving",
        "delay": "Vertraging",
        "filter_value": "Waarde",
        "filter_key": "Filter",
        "required_confirmations": "Vereiste bevestigingen",
        "filter_comparator": "Comparator",
        "filter_value_seconds": "Seconden"
      }
    },
    "users": {
      "fields": {
        "username": "Gebruikersnaam",
        "group_restrictions": "Restricties (op groep)",
        "roles": "Rollen",
        "lastActiveAt": "Laatst actief op",
        "map_viewer": "Heeft toegang tot de kaart",
        "userPolicies": {
          "disablePasswordlessLogin": "Wachtwoordloos inloggen uitschakelen"
        },
        "accessRequest": {
          "validUntil": "Heeft toegang tot (Laat leeg als de toegang geen einddatum heeft)"
        },
        "certification_categories": "Certificaten"
      },
      "text": {
        "password_reset_sent": "Aanvraag voor wachtwoord opnieuw instellen verstuurd.",
        "password_reset_failed": "Aanvraag voor wachtwoord opnieuw instellen mislukt",
        "password_reset_button": "Verstuur e-mail: Wachtwoord opnieuw instellen",
        "password_reset_button_description": "Weet je zeker dat je de reset-e-mail naar deze gebruiker wilt sturen?",
        "password_reset_mail_confirm": "Verstuur email",
        "roles": {
          "app_user": "App-gebruiker - stel niet in",
          "map_viewer": "Kaart kijker",
          "centralist": "Centralist ",
          "customer_admin": "Klant admin",
          "viewer": "Kijker",
          "alarm_responder": "Alarm helper",
          "ats_responder": "ATS opvolger",
          "kioskUser": "Scherm gebruiker",
          "customer_admin_external_id": "Kan Extern Id toevoegen of aanpassen",
          "customer_admin_special_username": "Kan gebruikers aanmaken met een gebruikersnaam die niet gebaseerd is op het e-mailadres",
          "flic_hub_tester": "Flic hub tester",
          "customer_admin_app_user_history": "Kan de geschiedenis van app-gebruikers downloaden.",
          "fingerprinter": "Fingerprinter",
          "bhvk_trial": "BHV-Knop proefgebruiker",
          "bhvk_admin": "BHV-Knop admin-gebruiker",
          "apr_visible": "Kan Alarm Professional Response (Sequrix) starten",
          "sales_admin": "Sales admin",
          "support_admin": "Support admin"
        },
        "roles_title": "Rollen",
        "invalid_phone": "Moet een valide telefoonnummer zijn, startend met een +",
        "invalid_sms": "Moet een valide smsnummer zijn, startend met een +",
        "title": "Gebruikers",
        "customer_user_relations": "Klant-gebruiker relaties",
        "update_success": "Gebruiker bijgewerkt",
        "admins_title": "Admins",
        "username_already_exists": "Deze gebruikersnaam is al bezet, kies een andere om door te gaan",
        "page_info": "Deze pagina laat gebruikers zien die kunnen inloggen op de X-Guard Alarm Manager en/of het X-Guard Management Dashboard.",
        "access_to_dashboard": "Toegang tot dashboard",
        "receives_alarms": "Ontvangt BHV-Oproepen",
        "saving_successful": "Gebruiker opgeslagen!",
        "sub_title": "Op deze pagina vind u alle gebruikers binnen de BHV-Knop omgeving. Er zijn instellingen per gebruiker.",
        "available": "Ontvangt alarmen",
        "create_success": "Gebruiker aangemaakt",
        "has_access_to_dashboard": "Heeft toegang tot het Management dashboard",
        "has_access_to_am": "Heeft toegang tot de Alarm Manager",
        "add": "Gebruiker toevoegen",
        "manually": "Handmatig",
        "username_should_be_email": "Gebruikersnamen moeten gebaseerd zijn op het e-mailadres van de gebruiker. Als u dit niet doet, wordt het inloggen voor deze gebruiker moeilijker.",
        "delete_users": "Verwijder gebruikers",
        "delete_users_warning": "Weet u zeker dat u deze gebruiker wilt verwijderen? |||| Weet u zeker dat u %{smart_count} gebruikers wilt verwijderen?",
        "users_with": {
          "multiple_connections": "Waarschuwing! Er is een gebruiker verbonden met meerdere klanten. Bekijk deze hieronder. |||| Waarschuwing! Er zijn gebruikers verbonden met meerdere klanten. Bekijk ze hieronder."
        },
        "2fa_title": "Twee-factor-authenticatie",
        "2fa_enable_description": "Met Twee-factor authenticatie ingeschakeld is uw account veiliger. Wanneer ingeschakeld, wordt u gevraagd om de code in de Authenticator-app van uw keuze telkens wanneer u inlogt op het Management Dashboard met dit account. Om door te gaan, scant u de onderstaande code met uw Authenticator-app, zoals Google Authenticator.",
        "2fa_code": "Code",
        "2fa_enable": "Inschakelen",
        "2fa_enabled": "Twee-factorauthenticatie ingeschakeld",
        "2fa_enable_failed": "Het inschakelen van twee-factor authenticatie is mislukt",
        "2fa_already_enabled": "Twee-factor authenticatie is al ingeschakeld voor uw account. Om het uit te schakelen, vult u hieronder uw Twee-factor authenticatie-code in. De herstelcodes die zijn gegenereerd bij het instellen van Twee-factor authenticatie kunnen ook worden gebruikt om uw Twee-factor authenticatie uit te schakelen.",
        "2fa_disabled": "Twee-factor authenticatie succesvol uitgeschakeld",
        "2fa_disable_failed": "Uitschakelen van twee-factor authenticatie mislukt",
        "2fa_disable": "Uitschakelen",
        "2fa_recovery_codes": "Dit zijn de recoverycodes voor de twee-factor authenticatie voor dit account. Kopieer deze codes en bewaar ze ergens, want ze kunnen u toegang geven tot uw account wanneer uw Authenticator zelf niet beschikbaar is.",
        "2fa_recovery_codes_copied": "Herstelcodes gekopieerd naar klembord",
        "customer_passwordless_disabled_tooltip": "Wachtwoordloos inloggen uitgeschakeld binnen klant"
      }
    },
    "customers": {
      "text": {
        "title": "Klanten",
        "alarmcenter_queueName": "Meldkamer wachtrij (vraag Jesse of Luuk)",
        "alarmcenter_title": "Meldkamers",
        "update_success": "Klant bijgewerkt",
        "uuid_validation": "Moet een geldig UUID zijn",
        "title_single": "Klant",
        "create_success": "Klant aangemaakt!",
        "create_preview_title": "Wordt aangemaakt",
        "create_preview": {
          "customer": "Klant",
          "structure": "Structuur",
          "triggers": "Observatie-triggers",
          "ats": "ATS-klantkoppelingen",
          "qr": "QR-registratie",
          "reports": "Rapporten",
          "bhvk_merge": "Merge uit; zelfde severity + type; 15 min venster; ATS retrigger 5 min",
          "bhvk_no_relations": "Geen parent / meldkamer / response partners / billing",
          "bhvk_ats_button": "BHV-Knoppen → BHV onderlinge-melding template (rood + oranje)",
          "bhvk_ats_other": "Alles behalve knopgroepen → rood/oranje, groen, alle templates",
          "bhvk_qr": "Legacy Main QR met config group BHV-Knop.nl en asset group BHV",
          "bhvk_report_alarms": "Wekelijkse rode alarmen (theme bhvk, lege ontvangers)",
          "bhvk_report_inactivity": "Inactiviteitsmonitor 40u op knopgroepen (theme bhvk, lege ontvangers)",
          "xgac_ats": "Rood+oranje, groen, alle (3 koppelingen)",
          "bhvk_ats_paniek": "Paniekknoppen → AIT onderlinge-melding template (rood + oranje)"
        }
      },
      "fields": {
        "locale": "Taal",
        "responsePartner": "Is mobiele surveillant",
        "responsePartners": "Mobiele surveillanten",
        "responsePartner_name": "Mobiele surveillant",
        "alarmCenter_name": "Meldkamer",
        "alarmcenter_relation": {
          "enabled": "Ingeschakeld"
        },
        "mergeConfig": {
          "enabled": "Alarmen samenvoegen toestaan",
          "maxTimeBetweenAlarmsMs": "Maximale tijd tussen alarmen ( seconden )",
          "retriggerAtsAfterMs": "Verstuur opnieuw naar ats na tijd ( seconden )",
          "onlyMergeWhenSame": "Alleen samenvoegen als een (of meerdere) van deze velden hetzelfde is",
          "use_default": "Gebruik standaard configuratie voor samenvoegen"
        },
        "alarmAgeLimit": "Alarmen zichtbaar voor",
        "hasAlarmAgeLimit": "Heeft gelimiteerde leeftijd van zichtbare alarmen",
        "kiosk_config": {
          "what_groups": "Welke groepen assets wilt u tonen?",
          "what_labels": "Welke labels wilt u tonen?",
          "which_functions": "Welke functies wilt u inschakelen?",
          "show_alarms": "Alarmen tonen",
          "manage_availability": "Beschikbaarheid beheren",
          "screen_schedule": "Schermschema",
          "incident_counter": "Incidententeller",
          "front_page": "Voorpagina",
          "anonymise_data": "Data anonimiseren",
          "incident_counter_count_from_date": "Tel vanaf datum",
          "incident_counter_threshold": "Drempelwaarde (Verberg de counter bij een recent incident)",
          "incident_counter_threshold_helper_text": "Als er geen datum is ingesteld, worden de dagen sinds het laatste incident geteld.",
          "manage_availability_pin": "Pincode",
          "manage_availability_app_hint": "Toon hint: App installeren",
          "manage_availability_show_search": "Zoekbalk altijd tonen",
          "manage_availability_show_label_filter": "Label filter altijd weergeven",
          "alarm_audio": "Maak geluid bij alarm",
          "alarm_flash": "Flits scherm bij alarm",
          "alarm_show_position_labels": "Toon alarmposities op kaart",
          "alarm_anonymous": "Data anonimiseren",
          "alarm_mode": "Alarm mode",
          "alarm_acknowledge": "Alarm afmelden",
          "alarm_acknowledge_pin": "Code voor afmelden van alarmen",
          "asset_inside_zones": "Laat alleen assets binnen zones zien",
          "hardware": "Hardware",
          "screen_brightness": "Scherm helderheid",
          "countAssets": "Asset groepen die in de teller moeten worden opgenomen",
          "flash": "Optisch signaal",
          "logo": "Zichtbaar logo",
          "schedule_entries": "Wanneer moet het scherm worden ingeschakeld?",
          "anonymise_data_description": "Wilt u volledige namen (en eventueel foto's) op de homepage van uw kiosk tonen? Op de anonieme versie van de kiosk worden alleen tellers getoond.",
          "what_groups_description": "Uw organisatie kan uit verschillende groepen mensen bestaan. Selecteer de relevante groepen die u op deze kiosk wilt weergeven.",
          "logo_description": "Indien u geen logo uploadt, is het standaard X-Guard of BHV-Knop.nl logo zichtbaar op de kiosk.",
          "manage_availability_description": "Wilt u deze kiosk gebruiken om de beschikbaarheid te beheren? Deze functie is alleen nuttig in kiosken waaraan een touchscreen of muis is bevestigd.",
          "manage_availability_pin_description": "U kunt de bewerkingsbeschikbaarheid optioneel beveiligen met een pincode. Laat dit leeg als u geen pincode nodig heeft.",
          "show_alarms_description": "Wilt u actieve alarmen weergeven op de kiosk? Dit kan uw personeel helpen de locatie van het alarm te lokaliseren en daar zo snel mogelijk naartoe te gaan.",
          "alarm_anonymous_description": "Tijdens een alarmsituatie laten wij zien wie er wordt opgeroepen en wie heeft ingestemd met het reageren op het alarm. U kunt ervoor kiezen om deze gegevens te anonimiseren.",
          "flash_description": "Tijdens een alarmsituatie zal er knipperen optreden.",
          "alarm_acknowledge_description": "Met deze functie kunt u deze kiosk gebruiken om snel samen te vatten wat er is gebeurd en het alarm te bevestigen. ",
          "alarm_acknowledge_pin_description": "Wilt u de alarmbevestiging beveiligen met een pincode?",
          "incident_counter_description": "Om een veilige werkomgeving te bevorderen kunt u op de homepage van uw kiosk een incidententeller tonen.",
          "incident_counter_count_from_date_description": "Vanaf welke datum wilt u dat de incidententeller begint te tellen? U kunt kiezen tussen de laatste alarmdatum en een vaste datum die u zelf opgeeft.",
          "screen_schedule_description": "Om het kioskscherm te beschermen, kunt u het schermschema inschakelen. Buiten het gedefinieerde schema wordt het scherm uitgeschakeld.",
          "schedule_entries_description": "Buiten deze tijden is het scherm zwart. Door het scherm aan te raken wordt de kiosk ingeschakeld, zelfs buiten het schema.",
          "manage_availability_pin_error": "Pin moet tussen de 4 en 6 karakters lang zijn.",
          "sound_description": "Tijdens een alarmsituatie zal een luid geluid optreden. Houd er rekening mee dat de alarmgeluidsfunctie alleen betrouwbaar beschikbaar is op voorgeprogrammeerde kiosken van BHV-Knop.nl.",
          "sound": "Geluid bij alarm",
          "alarm_sound": "Kies uw geluid",
          "alarm_sound_description": "Welk geluid u tijdens een alarmsituatie wilt afspelen, bepaalt u geheel zelf. U kunt kiezen voor iets dat lijkt op een brandalarm of iets heel zachts.",
          "alarm_sound_volume": "Geluidsvolume",
          "alarm_sound_volume_description": "Wij raden aan om het volume op 100% te zetten, maar als u dit te luid vindt, kunt u het hier aanpassen.",
          "alarm_sound_stop_after_touch": "Stop het geluid bij aanraking",
          "alarm_sound_stop_after_touch_description": "De kiosk stopt met het afspelen van het alarmgeluid wanneer u het scherm aanraakt.",
          "alarm_sound_stop_after_seconds": "Stop geluid na...",
          "alarm_sound_stop_after_seconds_description": "Na hoeveel seconden wilt u dat het alarmgeluid stopt? U kunt er ook voor kiezen om het te laten herhalen totdat het alarm is afgemeld.",
          "count_label_separately": "Teller per groep",
          "count_label_separately_description": "Het is mogelijk om per gekozen groep tellen in plaats van het tonen van de totaaltelling.",
          "alarm_mode_description": "De alarmmodus bepaalt of er alleen alarmen worden weergegeven voor de zone waarin de kiosk zich bevindt, of voor alle alarmen in dit account.",
          "alarm_modes": {
            "zoneBased": "Alarmen in zone weergeven",
            "customerBased": "Alle alarmen weergeven"
          }
        },
        "disableAutomaticGenerationOfButtonZones": "Automatisch genereren van zones voor knoppen uitschakelen",
        "alarmCenter": {
          "phoneNumber": "Meldkamer terugbelnummer"
        },
        "userPolicies": {
          "disablePasswordlessLogin": "Wachtwoordloos inloggen voor gebruikers uitschakelen"
        },
        "securityInventoryEnabled": "Beveiligingsinventaris ingeschakeld",
        "recurringTasksEnabled": "Terugkerende taken ingeschakeld",
        "enableZoneEnterExitEvents": "Zone binnenkomst-/vertrekgebeurtenissen inschakelen",
        "customerProduct": {
          "label": "Klanttype",
          "xgac": "X-Guard",
          "bhvk": "BHV-knop.nl"
        }
      }
    },
    "tags": {
      "text": {
        "title": "Tag"
      }
    },
    "devices": {
      "text": {
        "title": "Apparaten",
        "types": {
          "lora": "Lora",
          "appDevice": "App apparaat",
          "flic": "Flic",
          "generic": "Algemeen",
          "loraGateway": "Lora basisstation"
        },
        "no_lora_config": "Geen specifieke Lora configuratie",
        "error_getting_devices": "Error bij het ophalen van apparaten",
        "result": "Resultaat",
        "downLink_explanation": "Stuur een Hex payload voor IoTracker apparaten op het KPN netwerk.",
        "buttons": "Knoppen"
      },
      "fields": {
        "deviceId": "Apparaat ID",
        "type": "Type",
        "loraConfig": {
          "type": "Lora apparaat type",
          "fieldtest": "Veldtest observatie code",
          "beaconScan": "Baken observatie code",
          "gps": "GPS observatie code",
          "preMandown": "Pre ManDown observatie code",
          "mandown": "ManDown observatie code",
          "alarmSeverity": "Alarm observatie code",
          "alive": "Lege observatie code",
          "floodDetected": "Water gedetecteerd observatie code",
          "noFloodDetected": "Geen water gedetecteerd observatie code",
          "type_help": "Controleer of het juiste apparaat-type geselecteerd is. Bij een verkeerd apparaat-type wordt de aangepaste configuratie niet toegepast.",
          "movement": "Beweging observatie code"
        },
        "battery": "Batterij"
      },
      "actions": {
        "downLink": "Downlink"
      }
    },
    "flic-buttons": {
      "text": {
        "invalid_hub_id": "Onjuist hub ID",
        "title": "Flic knoppen",
        "found_button": "Knop gedetecteerd!",
        "config": {
          "title": "Gebruik de volgende configuratie voor de knop:",
          "single_click_title": "Enkele klik",
          "single_click_description": "Update knop meta-info",
          "double_click_title": "Dubbele klik",
          "double_click_description": "Volg het laatste alarm gemaakt door dezelfe asset op (sluit)",
          "hold_title": "Knop ingedrukt houden",
          "hold_description": "Maak alarm volgens bovenstaande configuratie",
          "hub_action": "Hub actie",
          "internet_request": "Internet verzoek",
          "url": "URL",
          "method": "Methode",
          "method_post": "POST",
          "description": "Beschrijving"
        },
        "waiting_for_press": "Wachten op klik van knop",
        "test_mode_active_until": "Test mode actief tot",
        "activate_test_mode": "Activeer test mode",
        "test_mode": "Test mode"
      },
      "fields": {
        "action": "Actie",
        "serial": "Serienummer",
        "battery": "Batterij",
        "deleted": "Verwijderd"
      }
    },
    "flic-hubs": {
      "text": {
        "title": "Flic hubs"
      },
      "fields": {
        "alarmLevel": "Alarm niveau",
        "xgacCustomerId": "Klant"
      },
      "go_to_buttons": "Knoppen"
    },
    "observation-triggers": {
      "text": {
        "title": "Observatie triggers",
        "general": "Algemeen",
        "action_config": "Configuratie van acties",
        "add_action": "Actie toevoegen",
        "add_eventcode": "Event code toevoegen",
        "filter": "Filter"
      },
      "fields": {
        "eventCodes": "Event code",
        "description": "Beschrijving",
        "active_status": "Is actief",
        "type": "Type",
        "config": {
          "\u0000": "Configuratie",
          "available_false": "Niet beschikbaar",
          "toContactList": "Contactlijsten",
          "toRaw": "Ontvangers",
          "available_true": "Beschikbaar",
          "customer_default": "Klantstandaard",
          "toTriggerUser": "Triggerende gebruiker",
          "do_not_change": "Niet wijzigen"
        },
        "filter_type": "Filtertype",
        "action_type": "Actietype",
        "schedule_entries": "Schemaregels",
        "days": "Dagen",
        "operands": "Voorwaarden",
        "operand": "Voorwaarde",
        "timeStart": "Starttijd",
        "timeEnd": "Eindtijd",
        "match": "Overeenkomst",
        "condition_block": "Voorwaardenblok"
      },
      "action_types": {
        "alarm": "Alarm",
        "sms": "Sms",
        "email": "E-mail",
        "assetUpdate": "Asset bijwerken"
      },
      "filter_types": {
        "operator_or": "Een van de voorwaarden",
        "constraint_assetGroup": "Assetgroep",
        "operator_and": "Alle voorwaarden",
        "constraint_asset": "Asset",
        "constraint_zone": "Zone",
        "operator_not": "Niet",
        "constraint_schedule": "Schema",
        "operator_none": "Geen voorwaarden"
      },
      "validation": {
        "time": "Voer een geldige tijd in (UU:mm)"
      },
      "match_types": {
        "matches": "Komt overeen",
        "does_not_match": "Komt niet overeen"
      }
    },
    "overlays": {
      "text": {
        "title": "Plattegronden",
        "overlay_not_found": "Plattegrond niet gevonden of aangepast",
        "create": "Plattegrond toevoegen",
        "delete_dialog_title": "Plattegrond verwijderen",
        "delete_dialog_content": "Weet u zeker dat u deze plattegrond wil verwijderen?",
        "add_marker": "Voeg een marker toe door op de gewenste locatie op de kaart te klikken om door te gaan met toevoegen.",
        "place_marker": "Plaats marker in het midden van het gebouw"
      },
      "fields": {
        "image": "Plattegrond",
        "image_url": "Foto url",
        "points": "Punten"
      },
      "notifications": {
        "overlay_too_small": "Plattegrond te klein. Bewerk deze om deze groter te maken."
      }
    },
    "qr-templates": {
      "text": {
        "title": "QR code sjablonen",
        "mail_recipient_types": {
          "asset": "asset",
          "manual": "handmatig"
        },
        "generating_qr": "QR code wordt gegenereerd, even wachten aub...",
        "code_created": "Code aangemaakt",
        "code_created_failed": "Code niet aangemaakt",
        "code_updated": "Code bijgewerkt",
        "code_updated_ failed": "Code update mislukt",
        "code_deleted": "Code verwijderd",
        "code_deleted_failed": "Code niet verwijderd",
        "options": "Opties",
        "default_qr": "Standaard QR",
        "brochure_nl": "Brochure NL",
        "brochure_en": "Brochure EN",
        "field": "Veld",
        "value": "Waarde",
        "locked": "Gesloten",
        "external_id": "Extern ID",
        "first_name": "Voornaam",
        "last_name": "Achternaam",
        "user_email": "Email van de gebruiker",
        "phone_prefix": "Telefoon land prefix",
        "phone_number": "Telefoonnummer",
        "available": "Beschikbaar",
        "limit": "Limiet",
        "save_first": "Sla op voordat codes toegevoegd kunnen worden",
        "codes": "Codes",
        "actions_save_first": "Sla op voordat acties toegevoegd kunnen worden",
        "registering_title": "Aan het registreren, even wachten...",
        "uploading": "Aan het uploaden...",
        "download_qr": "QR downloaden of bekijken",
        "preview": "Bekijken",
        "single_title": "QR sjabloon",
        "sends_email": "Verstuurt email",
        "paused": "Registratie beveiliging gepauzeerd",
        "pause_throttle": "Registratie beveiliging pauzeren",
        "pause_throttle_explanation": "Als je met een groep aan het registreren bent, klik op de onderstaande knop. De groepsregistratie is mogelijk voor 1 uur.",
        "end_pause_throttle": "Schakel beveiliging nu in"
      },
      "fields": {
        "group_list": "Groep lijst",
        "recipient_type": "Ontvanger type",
        "template_label": "Sjabloon label",
        "template_value": "Sjabloon waarde",
        "recipient_list": "Ontvanger lijst",
        "template_updated": "Sjabloon bijgewerkt",
        "template_update_failed": "Sjabloon niet bijgewerkt",
        "pages": "Paginas",
        "visible": "Zichtbaar",
        "actions": "Acties"
      }
    },
    "service-accounts": {
      "text": {
        "title": "Service Accounts",
        "username_validation": "Gebruikersnaam van een service account moet starten met \"sa-\""
      }
    },
    "static-responders": {
      "text": {
        "title": "Statische helpers",
        "days": {
          "monday": "Maandag",
          "tuesday": "Dinsdag",
          "wednesday": "Woensdag",
          "thursday": "Donderdag",
          "friday": "Vrijdag",
          "saturday": "Zaterdag",
          "sunday": "Zondag",
          "all": "Alle dagen",
          "weekdays": "Werkdagen",
          "weekends": "Weekend"
        },
        "general": "Algemeen",
        "contact_options": "Contact opties",
        "availability": "Beschikbaarheid",
        "professional_response": "Mobiele surveillant",
        "postcodes": "Postcodes"
      },
      "fields": {
        "schedule_entry_add": "Schema toevoegen",
        "contact": {
          "camera": "Camera"
        },
        "externalId": "Contact code",
        "schedule": {
          "name": "Schema",
          "entries": "Huidige schema"
        },
        "days_of_week": "Dagen van de week",
        "time_start": "Starttijd",
        "time_end": "Eindtijd",
        "integrations": {
          "sequrix": {
            "enabled": "Sequrix",
            "objectCode": "Objectcode"
          }
        }
      },
      "notifications": {
        "postcodes_updated": "Statische helpers nu beschikbaar in geselecteerde zone(s)",
        "no_changes": "Geen wijzigingen gevonden in opvolgers",
        "invalid_postcode": "Postcode ongeldig, probeer het opnieuw"
      }
    },
    "webhooks": {
      "text": {
        "title": "Webhooks",
        "entity": "Entiteit",
        "filter_explanation": "Webhook filter (Mongo query formattering)",
        "delivery": "Levering",
        "enabling": "Inschakeling",
        "output_preview": "Uitvoervoorbeeld"
      },
      "fields": {
        "enableWebhook": "Webhook ingeschakeld",
        "webhookQuery": {
          "operation": "Operatie",
          "entityTypes": "Entiteit types",
          "filter": "Filter"
        },
        "deliveryConfig": {
          "method": "Methode",
          "url": "Url",
          "headers": "Headers"
        },
        "deliveryStats": {
          "numDeliverySucceeded": "Aantal succesvolle leveringen",
          "numDeliveryFailed": "Aantal gefaalde leveringen",
          "lastDeliveryDate": "Laatste succesvolle levering"
        }
      }
    },
    "zones": {
      "text": {
        "zoneTypes": {
          "default": "Standaard",
          "response_area": "Reactie gebied",
          "police_department": "Politiebureau",
          "fingerprinted": "Fingerprinted",
          "assetMonitoredArea": "Automatisch schakel gebied",
          "building": "Gebouw",
          "evacuationPoint": "Evacuatiepunt"
        },
        "title": "Zones",
        "polygon_should_smaller": "De polygon moet kleiner zijn dan een halfrond",
        "one_figure_per_zone": "Er kan 1 figuur per zone toegevoegd worden.",
        "invalid_zone": "Zone is niet valide: Meer of minder dan 1 figuur.",
        "title_single": "Zone",
        "invalid_zone_intersection": "Zone is niet valide: Kruist zichzelf.",
        "syncToAms_explanation": "Wanneer aangezet, wordt deze zone gesynchroniseerd naar AMS. Hierdoor kunnen apparaten schakelen bij het in/uitgaan van de zone.\nOp dit moment alleen relevant voor het schakelen van BHV-Knop.nl beschikbaarheid, dit wordt later uitgebreid.",
        "beacons_in_zone": "Gekoppelde bakens",
        "assets_inside": "Er is nu %{smart_count} persoon in deze zone |||| Er zijn nu %{smart_count} personen in deze zone",
        "updated": "Zone updated!",
        "assets_inside_dialog_title": "Personen in deze zone",
        "zone_list": "Zone lijst",
        "manage": "Beheer zones",
        "created": "Zone toegevoegd!",
        "delete": "Zone verwijderen",
        "deleted": "Zone verwijderd",
        "create_mode_dialog_title": "Wilt u deze zone als punt op de kaart of als gebied aanmaken?",
        "area": "Gebied",
        "area_subtext": "Teken een gesloten gebied op de kaart",
        "marker": "Punt op de kaart",
        "marker_subtext": "Eén punt op de kaart.\nGeschikt voor lokalisatie met X-Guard Bakens",
        "edit_warning": "U bewerkt momenteel een zone. Sla deze op of annuleer de wijzigingen.",
        "still_editing_warning": "U bewerkt momenteel een zone. Sla deze op of annuleer de wijzigingen.",
        "assets_inside_empty": "Er zijn nu geen personen in deze zone",
        "create_dialog_where_title": "Waar wilt u deze zone plaatsen?",
        "create_dialog_where_map": "Ik kies zelf de positie op de kaart",
        "create_dialog_where_input": "Op een adres",
        "delete_disabled_ams_or_beacons": "Deze zone wordt gebruikt in de geavanceerde interne configuratie en mag niet worden verwijderd.",
        "delete_disabled_links_or_triggers": "Deze zone wordt gebruikt in de geavanceerde interne configuratie en mag niet worden verwijderd.",
        "zones_with_similar_prints": "Er is %{smart_count} paar zones met overeenkomende data, klik om meer te zien |||| Er zijn %{smart_count} paar zones met overeenkomende data. Klik om meer te zien",
        "customers_with_same_codes": "Baken codes gevonden in andere klantomgevingen. Klik om meer te zien",
        "zones_with_similar_prints_title": "Zones met vergelijkbare prints",
        "customers_with_same_codes_title": "Klanten met identieke codes in print",
        "not_fingerprinted_zones": "Zones zonder of met weinig fingerprints",
        "zones_with_bad_prints": "Er is 1 zone met fingerprints die niet genoeg bakens hebben om van kwaliteit te zijn. Klik om meer te zien. |||| Er zijn %{smart_count} zones met fingerprints die niet genoeg bakens hebben om van kwaliteit te zijn. Klik om meer te zien.",
        "zones_with_bad_prints_title": "Zones met slechte prints",
        "beacon_calc": {
          "open_button": "IPS offerte",
          "dialog_title": "Berekende kamers",
          "table": {
            "beacons": "bakens",
            "room_size": "Grootte",
            "room_number": "Aantal",
            "total_square_meters": "Totale m²",
            "beacon_number": "Geschat aantal bakens",
            "fingerprint_time": "Fingerprinten",
            "beacon_place_time": "Bakens monteren",
            "total_time": "Totaal",
            "small": "Klein",
            "medium": "Middel",
            "large": "Groot"
          },
          "hours": "uur |||| uren",
          "minutes": "minuut |||| minuten"
        },
        "add_screen_subtext": "Genereer een scherm url",
        "no_zones": "Maak eerst een zone aan",
        "delete_disabled_kiosks": "Deze zone wordt gebruikt in een kiosk en mag niet worden verwijderd.",
        "filter_in_bounds": "Filter buiten kaart",
        "update_dialog_title": "Wilt u deze zone bijwerken?",
        "update_dialog_content": "Deze zone is gefingerprint. Het updaten van deze zone kan de fingerprints onnauwkeurig maken. Wilt u deze zone updaten?",
        "delete_disabled_fingerprinted": "Deze zone wordt gebruikt voor indoor-locatiebepaling",
        "alarm_professional_responder_count_dialog_title": "Sequrix-opvolgers per zone",
        "alarm_professional_responder_count_empty": "Kon zones niet ophalen"
      },
      "filters": {
        "only_show": "Type"
      },
      "fields": {
        "type": "Type",
        "description": "Beschrijving",
        "number_of_responders": "Aantal statische helpers",
        "responsePriority": "Prioriteit in opvolging",
        "number_of_beacons": "Aantal bakens",
        "number_of_assets": "Aantal personen in deze zone",
        "syncToAms": "Synchroniseer naar AMS",
        "alarm_position": "Alarmpositie",
        "fingerprintCount": "Aantal scans in fingerprints",
        "has_address_position": "Indien ingeschakeld wordt het ingevoerde adres gebruikt in de gehele gemarkeerde zone.",
        "postCodeRange": "Opvolgers per postcode",
        "postCodeRange_helper": "Bijv. 7413-7451, 7499",
        "postCodeRange_label": "Postcodebereik",
        "alarm_professional_responder_count_sequrix": "Sequrix-opvolgers",
        "alarm_professional_responder_count_no_sequrix": "Andere hulpverleners",
        "alarm_professional_responder_count_responders": "Sequrix-opvolgers"
      }
    },
    "contact-lists": {
      "text": {
        "title": "Contactlijsten",
        "contacts_number": "Aantal contacten"
      },
      "fields": {
        "contacts": "Contacten"
      }
    },
    "report-triggers": {
      "text": {
        "title": "Rapportage triggers",
        "granularity_types": {
          "minute": "Minuut/minuten",
          "hour": "Uur/uren",
          "day": "Dag(en)",
          "week": "Week/weken",
          "month": "Maand(en)",
          "quarter": "Kwartiel(en)",
          "year": "Jaar/jaren"
        },
        "config_types": {
          "unhealthyBeacons": "Ongezonde bakens",
          "observation": "Aantal observaties",
          "alarms": "Alarmen",
          "newAlarm": "Nieuw alarm",
          "inactivityMonitor": "Inactiviteit monitor",
          "appUsage": "Appgebruik",
          "assetHistory": "Assetgeschiedenis",
          "alarmCenterStatus": "Meldkamer status",
          "zoneOverview": "Zone status",
          "subtext": {
            "alarms": "Het alarmrapport verzendt een rapport met daarin een overzicht van de alarmen die sinds de laatste melding zijn gemaakt. Indien ingeschakeld, wordt het rapport de volgende maandag verzonden. Indien ingeschakeld wordt de rapportage de volgende maandag verstuurd, en daarna %{interval}.",
            "appUsage": "Het app-gebruiksrapport verzendt een rapport met daarin een overzicht van het gebruik van de app per gebruiker in de afgelopen maand. Indien ingeschakeld, wordt het rapport elke maand aan het begin van de maand verzonden.",
            "inactivityMonitor": "Deze rapportage wordt verstuurd op het moment dat een knop zich meer dan 24 uur niet meldt. Dit kan verschillende redenen hebben, zoals een lege batterij, geen connectie hebben met het basisstation, of een fysiek defect. Als deze mail verzonden wordt, staat daarin ook wat de vervolgstappen zijn.",
            "unhealthyBeacons": "De ongezonde baken rapportage bevat bakens die niet recent gezien zijn, of lage batterijpercentage hebben. De rapportage wordt %{interval} verstuurd.",
            "alarmCenterStatus": "De alarmcentrale status rapportage bevat informatie over de alarmen die geëscaleerd zijn naar deze meldkamer.",
            "newAlarm": "De nieuwe alarm rapportage verstuurt op het moment dat er een nieuw alarm gemaakt wordt. Deze wordt niet verstuurd voor testalarmen."
          }
        },
        "config": {
          "excel_types": {
            "default": "Standaard",
            "smc": "SMC"
          }
        },
        "channel_types": {
          "contact_list": "Contactlijst"
        },
        "go_contactlist": "Klik om naar contactlijst(en) te gaan.",
        "licence_modes": {
          "hourlyUsage": "Uurlijks gebruik",
          "license": "Licentie"
        },
        "filter_tags": {
          "active": "Actief",
          "inactive": "Inactief",
          "new": "Nieuw",
          "forgotten": "Vergeten"
        },
        "invalid_email": "Een of meerdere invalide email adres(sen)",
        "not-exists": "Trigger bestaat niet meer",
        "theme": {
          "default": "Standaard (X-Guard)",
          "bhvk": "BHV-Knop.nl"
        },
        "send-for-current-month": "Retroactief voor de huidige maand verzenden",
        "send-current-month-unavailable": "Deze rapportage kan niet meer verstuurd worden voor deze maand",
        "unsubscribedEmails_helper": "Adressen in dit veld krijgen dit rapport niet toegestuurd."
      },
      "fields": {
        "config": {
          "type": "Type",
          "last_seen_threshold": "Laatst gezien drempel",
          "excelFormat": "Excel formattering",
          "alarmTypes": "Alarm types",
          "timeSeries_title": "Tijdreeksen",
          "severities": "Alarmurgenties",
          "timeSeries": {
            "granularity": "Granulariteit",
            "timeframe": "Tijdsspanne"
          },
          "app_mode": "App mode",
          "timeout": "Time-out",
          "floorTo": "Afronden op",
          "agOptions": {
            "includeRaw": "Ruwe data bijvoegen",
            "includeSimple": "Simpele data bijvoegen"
          },
          "excludeCustomers": "Klanten uitsluiten"
        },
        "enabled": "Ingeschakeld",
        "lastRunAt": "Laatste uitvoering op",
        "nextRunAt": "Volgende uitvoering op",
        "runInterval_title": "Uitvoeringsinterval",
        "channels": "Kanalen",
        "channels_type": "Type",
        "channels_address": "E-mailadressen",
        "time_granularity": {
          "value": "Aantal",
          "type": "Tijd"
        },
        "channels_number": "Nummers",
        "lastAttemptedAt": "Laatst geprobeerd op",
        "unsubscribedEmails": "UItgeschreven email adressen"
      }
    },
    "unhealthyBeacons": {
      "text": {
        "inactive": {
          "label": "Inactieve bakens"
        },
        "lowBattery": {
          "label": "Bakens met lage batterijspanning"
        },
        "noneFound": "Geen bakens gevonden binnen deze klant.",
        "noAttachments": "Geen bijlagen gevonden."
      }
    },
    "lite-templates": {
      "name": "QR Codes"
    },
    "app_users": {
      "text": {
        "groups_and_config_explanation": "Kies groepen en configuratie. Indien gewenst kan een QR sjabloon gebruikt worden als basis. De gekozen groepen en configuratie kunnen ingesteld worden op alle geselecteerde App-gebruikers. Voor de groepen en configuratie kan een keuze gemaakt worden tussen het vervangen van bestaande waardes, toevoegen aan bestaande waardes, of het overslaan van de waardes. De laatste keuze betekend dat de bestaande waarde op de App-gebruiker niet aangepast wordt."
      }
    },
    "domainlinks": {
      "title": "Domeinrestricties"
    },
    "domainlink": {
      "fields": {
        "domain": "Domein"
      }
    },
    "buttons": {
      "text": {
        "manage_buttons": "Beheer knoppen",
        "search": "Apparaten doorzoeken",
        "show_all": "Toon alle knoppen",
        "coordinates_small": " (versleep de punt op de kaart)",
        "gateway_map_disclaimer": "De cirkel rond een basisstation is enkel een indicatie van bereik.",
        "mass_move_title": "Verplaats meerdere knoppen",
        "move_confirm_button": "Verplaats",
        "mass_move_explanation": "Stap 2: Kies het adres",
        "button_number_tooltip": "Het knopnummer is gestickerd aan de onderkant van de BHV-Knop",
        "gateway_number_tooltip": "Het nummer van het Basisstation is gestickerd op het apparaat",
        "test_button_title": "U ontvangt een melding",
        "test_button_content": "Deze melding gaat alleen naar u, niet naar alle BHV'ers. Wilt u testen met alle BHV'ers? Dan kunt u de knop daadwerkelijk indrukken.",
        "test_sent": "Test-alarm verstuurd. U ontvangt deze via een telefoontje",
        "test_disabled": "Testen niet beschikbaar omdat de ingelogde gebruiker geen app geïnstalleerd heeft, of geen telefoonnummer heeft ingevoerd.",
        "print_all_labels": "Print alle labels",
        "print_all_labels_confirm": "Weet je zeker dat je alle labels wilt printen?",
        "sufficient_battery": "Voldoende batterij",
        "show_buttons": "Bekijk knoppen",
        "building_dialog": {
          "0": {
            "title": "Een gebouw toevoegen",
            "explanation": "Aan de hand van het gevonden adres proberen we automatisch uw gebouw in te laden met de beschikbare gegevens van de kadastrale kaart.",
            "input_label": "Zoek uw adres...",
            "input_upper_label": "Zoek uw volledige adres op"
          },
          "1": {
            "title": "Gebouw gevonden",
            "explanation": "We hebben uw gebouw blauw gearceerd. Heeft u meerdere gebouwen die bij het door ingevoerde adres en huisnummer horen, dan kunt u deze ook selecteren. Indien niet het juiste gebouw geselecteerd is, dan kunt u dit hier teven corrigeren.",
            "surface_area": "Oppervlakte %{area} m²",
            "next_button": "Ga verder met het geselecteerde gebouw |||| Ga verder met de geselecteerde gebouwen",
            "building_count": "%{smart_count} gebouw |||| %{smart_count} gebouwen"
          },
          "2": {
            "title": "Gebouw %{building} van %{max}",
            "how_many_floors": "Hoeveel bouwlagen heeft het gebouw?",
            "floors": "bouwlagen",
            "next_button": "Bekijk het voorstel",
            "next_builing_button": "Naar het volgende gebouw",
            "office_or_factory": "Wat beschrijft dit gebouw het beste?",
            "office": "Kantoor",
            "factory": "Fabriek of hal",
            "button_distance_title": "Maximale loopafstand tot een knop",
            "button_distance_sub_title": "Voorbeeld: handbrandmelders hangen op 30 meter loopafstand",
            "button_distance_button": "%{distance} meter",
            "recommended": "Ons advies"
          },
          "3": {
            "title": "Ons voorstel",
            "next_button": "Voeg de producten toe",
            "view_price": "Bekijk wat het kost"
          },
          "no_streetnumber": "Geen huisnummer gevonden voor gekozen adres",
          "change_later": "U kunt dit later nog eenvoudig aanpassen",
          "building": "Gebouw",
          "not_in_countries": "Selecteer een gebouw binnen Nederland of Vlaanderen.",
          "max_buildings": "Het is aangeraden om niet meer dan %{count} gebouwen in een keer toe te voegen.",
          "no_buildings_found": "Geen gebouwen gevonden op het opgegeven adres"
        },
        "map_default": "Kaart",
        "map_satellite": "Satelliet",
        "map_center": "Centreren",
        "floors_chosen": "Bouwlagen geselecteerd",
        "all_floors": "Alle bouwlagen",
        "actions_with_selected": "Acties met geselecteerde",
        "mass_move": "Verplaatsen",
        "add_gateway": "Basisstation toevoegen",
        "add_button": "Knop toevoegen",
        "create_dialog_title_gateway": "Waar wilt u dit basisstation plaatsen?",
        "create_dialog_title_button": "Waar wilt u deze BHV-Knop plaatsen?",
        "how_many_gateways": "Hoeveel basisstations wilt u toevoegen?",
        "how_many_buttons": "Hoeveel BHV-Knoppen wilt u toevoegen?",
        "no_concept_devices": "Er zijn geen onbetaalde BHV-Knoppen of basisstations gevonden in de door u geselecteerde apparaten.",
        "unpaid_devices": "U hebt onbestelde producten",
        "delete_unpaid": "Verwijder deze producten",
        "deleted_unpaid_devices": "Onbestelde apparaten verwijderd",
        "delete_are_you_sure": "Weet u zeker dat u deze apparaten wilt verwijderen?",
        "delete_add_again": "Deze apparaten kunnen gemakkelijk opnieuw toegevoegd worden",
        "deleted_unpaid_devices_error": "Er is een fout opgetreden tijdens het verwijderen van de apparaten.",
        "not_ordered": "Nog te bestellen",
        "place_button": "Plaats BHV-Knop(pen)",
        "place_gateway": "Plaats basisstation(s)",
        "stop_placing": "Stop apparaten plaatsen",
        "status": {
          "online": "Dit apparaat is online",
          "offline": "Dit apparaat is offline",
          "pending": "De status van dit apparaat wordt opgehaald",
          "empty": "De batterij van dit apparaat is (bijna) leeg",
          "lowRSSI": "Te ver weg",
          "highNoise": "Radiosignaal bevat ruis",
          "nobody_why": "Niemand opgeroepen, lees hier waarom"
        },
        "deviceType": "Type apparaat",
        "remove_filters": "Filters wissen",
        "save_filters": "Filters opslaan",
        "active_status_label": "Actieve status",
        "active_status": {
          "active": "Bestelde en actieve apparaten",
          "unpaid": "Onbestelde apparaten",
          "demo": "Demo apparaten"
        },
        "all_devices": "Alle types apparaten",
        "devices_chosen": "Apparaat types gekozen",
        "all_active_status": "Alle statussen",
        "active_status_chosen": "Status gekozen",
        "building_distance_warning": "De geselecteerde gebouwen liggen ver uit elkaar. Controleer of deze gebouwen bij \"%{address}\" horen. Een ander adres toevoegen is mogelijk door opnieuw een gebouw toe te voegen als u klaar bent met de huidige.",
        "create_alarm_uncontacted": " %{smart_count} niet eerder gecontacteerd persoon |||| %{smart_count} niet eerder gecontacteerde personen",
        "invalid_address": "We konden dit adres niet vinden in Nederland. Adressen buiten Nederland kunt u toevoegen door een losse BHV-Knop te plaatsen op uw pand.",
        "locked": "Vergrendeld",
        "unlocked": "Ontgrendeld",
        "create_alarm_confirm_title": "De onderstaande acties worden uitgevoerd wanneer een alarm wordt gemaakt met deze knop.",
        "create_alarm_current_address": "Huidig adres: ",
        "print_selected_labels": "Geselecteerde labels printen",
        "print_selected_labels_confirm": "Weet u zeker dat u de geselecteerde labels wilt printen?",
        "print_selected_labels_notify": "Geselecteerde labels worden geprint",
        "print_all_labels_notify": "Alle labels worden geprint",
        "no_labels_selected": "Er zijn geen labels met een geldig ID geselecteerd om af te drukken.",
        "print_labels_error": "Fout tijdens het afdrukken van labels"
      },
      "fields": {
        "address": "Tekstueel adres"
      },
      "automove_title": "Automatisch verplaatsen van knoppen",
      "groups_selected": "Groepen geselecteerd",
      "automove_no": "Nee, behoud huidige plek"
    },
    "notifications": {
      "move_multiple_no_location": "Er moet een locatie geselecteerd zijn voordat verplaatsen mogelijk is.",
      "moved_multiple": "Knoppen en/of basisstations verplaatst",
      "moved_multiple_error": "Error bij het verplaatsen, een of meerdere is niet succesvol verplaatst"
    },
    "report_triggers": {
      "text": {
        "to_whom": "Naar wie?",
        "specific_fields": "Velden specifiek voor report type"
      },
      "what_report": "Welk rapportage?"
    },
    "roles": {
      "title": "Rollen"
    },
    "reports": {
      "title": "Rapportages",
      "text": {
        "attached_email": "Gegenereerde email",
        "show_email": "Bekijk email",
        "sub_title": "Op deze pagina zijn de verschillende rapportages te vinden. Hier kunt u deze ook aan/uit zetten en bepalen naar wie de rapportage verstuurd wordt. Mist u een rapportage? Neem contact met ons op.",
        "recipients": "Ontvangers",
        "no_recipients": "Deze rapportage heeft geen ontvangers. Dit is geen correcte configuratie.",
        "confirm_dialog_content": "Weet u zeker dat u deze rapportage wilt uitschakelen?",
        "settings": "Rapportage settings",
        "hour": "%{smart_count} uur |||| %{smart_count} uur",
        "day": "%{smart_count} dag |||| %{smart_count} dagen",
        "week": "%{smart_count} week |||| %{smart_count} weken",
        "zones_no_data": "Op deze pagina kunt u zien wie er aanwezig was in uw zones in de afgelopen tijd.\n\nZo waarborgt u dat er voldoende personen aanwezig waren op het door u gewenste moment.",
        "zones_settings_title": "Live aanwezigheidsrapportage",
        "zones_settings_explain": "Deze rapportage toont live de huidige en vorige bezetting in de gekozen Zones.",
        "zones_settings": {
          "zone_helpertext": "Kies voor welke Zones u de grafieken wilt weergeven",
          "period_helpertext": "Kies hoe lang u wenst terug te kijken. Bij een langere periode wordt de getoonde data minder nauwkeurig.",
          "period": "Periode",
          "min_occupancy_helpertext": "Kies optioneel hoeveel mensen u wenst dat er aanwezig zijn. Dit is bijvoorbeeld het gewenste aantal BHV'ers.",
          "includeGroups_helpertext": "Kies welke gebruikersgroepen mogen meetellen als bezetting.",
          "inactivityThreshold": "Vereis activiteit in de app",
          "occupancy_title": "Hoeveel personen wenst u dat er aanwezig zijn?",
          "schedule": "Wilt u een schema instellen voor minimale bezetting?",
          "zone_title": "Welke zone wilt u monitoren?",
          "enabled": "Wil je e-mails ontvangen van deze grafiek?",
          "schedule_warning": "U kunt verschillende minimale bezetting instellen voor verschillende schema's",
          "asset_groups": "Welke groepen wilt u monitoren?"
        },
        "zones_no_groups": "Er zijn geen zones om te monitoren. Via de Zones pagina kunt u zones toevoegen.",
        "month": "%{smart_count} maand |||| %{smart_count} maanden",
        "subtext_week": "elke week |||| iedere %{smart_count} weken",
        "subtext_month": "elke maand |||| iedere %{smart_count} maanden",
        "subtext_day": "elke dag |||| iedere %{smart_count} dagen",
        "subtext_hour": "elk uur |||| iedere %{smart_count} uur",
        "subtext_quarter": "elk kwartaal |||| elke %{smart_count} kwartaal",
        "subtext_year": "elk jaar |||| iedere %{smart_count} jaar",
        "add_zone": "Nieuwe zone monitoren",
        "zone_monitor_added": "Monitoring gestart",
        "zone_monitor_updated": "Monitoring bijgewerkt",
        "sends_email": "Waarschuwingen per e-mail",
        "bhvk_title": "Beschikbaarheid in de afgelopen 7 dagen",
        "zone_monitor_loading_secondary": "Beschikbaarheid wordt geladen, even geduld aub...",
        "zoneOverview_filter_assets": "Toon alleen geselecteerde personen",
        "zoneOverview_filter_assets_tooltip": "Filter grafiek op personen",
        "zoneOverview_asset_settings": "Selecteer de personen die u in de grafiek wilt zien.",
        "last_week": "Afgelopen week",
        "last_month": "Afgelopen maand",
        "zoneOverview_timeseries_settings": "Selecteer de tijdsperiode van de grafiek."
      },
      "fields": {
        "attachments": "Bijlagen",
        "last_attachments": "Bekijk laatste email",
        "minOccupancy": "Gewenste bezetting",
        "occupancy": "Bezetting",
        "enable_warnings": "Waarschuwing versturen bij te weinig aanwezigheid",
        "enable_weekly": "Schakel wekelijkse e-mails in",
        "enable_monthly": "Schakel maandelijkse e-mails in",
        "enable_emails": "Wanneer ontvang ik de e-mails?",
        "hasAttachment": "Stuur een bijlage met een overzicht van wie er dagelijks in deze zone is geweest."
      },
      "title_single": "Rapportage"
    },
    "report-trigger-runs": {
      "title": "Rapportages",
      "empty": "Nog geen rapportages"
    },
    "kiosk-users": {
      "title": "Kiosks",
      "default_config": "Gebruikt standaard configuratie",
      "text": {
        "config_not_set": "Configuratie niet ingesteld",
        "created": "Scherm gebruiker aangemaakt",
        "set_zone": "Fout: Stel een zone in"
      },
      "fields": {
        "kioskConfig": {
          "managed": "Beheerd"
        },
        "fully_android_id": "Fully Kiosk Android ID",
        "fully_device_id": "Fully Kiosk Device ID",
        "managed": "X-Guard Beheerd"
      },
      "url_dialog_title": "Jouw Kiosk URL",
      "url_dialog_privacy": "Ik begrijp dat deze URL toegang geeft tot potentieel gevoelige informatie van mijn organisatie.",
      "url_dialog_show_once": "Ik begrijp dat deze URL eenmalig getoond wordt. De URL zal niet opnieuw getoond worden, en als ik deze kwijt raak zal er een nieuwe URL aangemaakt moeten worden.",
      "url_dialog_use_once": "Ik begrijp dat deze URL op 1 scherm tegelijkertijd gebruikt mag worden. Als u meer schermen heeft, maak dan meerdere unieke URL's in dit dashboard.",
      "kiosk_number": "Kiosknummer",
      "url_dialog_agree": "Ik begrijp dat als ik dit doe de URL opnieuw gegenereerd wordt. De oude, bestaande url zal niet meer werken."
    },
    "qr-code": {
      "text": {
        "single": "QR-code"
      }
    },
    "fingerprints": {
      "text": {
        "progress_zones": "Gefingerprinte zones",
        "progress_devices_in_fingerprint": "Apparaten in fingerprints",
        "progress_beacons_in_fingerprint": "Aantal bakens in fingerprints",
        "is_similar_to": "Komt overeen met",
        "similar_scans": "Overeenkomende scans",
        "other_customer": "Andere klant",
        "create_beacons": "Maak bakens voor codes in fingerprints",
        "missing_codes": "Codes van missende bakens",
        "create_beacons_button": "Maak bakens",
        "beacons_created": "%{smart_count} baken aangemaakt! |||| %{smart_count} bakens aangemaakt!",
        "beacons_not_created": "Bakens konden niet aangemaakt worden",
        "check_beacons": "Controleer of er bakens missen",
        "check_progress": "Check fingerprint voortgang en gezondheid",
        "disable_statistics": "Schakel vooruitgang en gezondheid uit",
        "change_zones": "Wijzig zone",
        "bulk_action_buttons_title": "Verander zones van geselecteerde fingerprints",
        "change_zones_description": "Weet je zeker dat je de zone van %{smart_count} fingerprint wilt wijzigen? |||| Weet je zeker dat je de zone van %{smart_count} fingerprints wilt wijzigen?",
        "change_zones_confirmation": "Ik begrijp het risico dat het veranderen van de zone met zich meebrengt voor een nauwkeurige locatiebepaling.",
        "zone_changed": "Zone bijgewerkt!",
        "error_changing_zone": "Fout tijdens het bijwerken van de zone"
      },
      "fields": {
        "userId": "Fingerprinted door"
      }
    },
    "kiosks": {
      "text": {
        "manage": "Beheer kiosks",
        "add_kiosk": "Kiosk toevoegen",
        "add_screen": "Scherm toevoegen",
        "general_settings_dialog": {
          "title": "Algemene kioskinstellingen",
          "switch_availability": "Aan- en afmelden"
        },
        "kioskConfig": {
          "homepage": {
            "incidentCounter": {
              "last_alarm": "Vanaf het laatste alarm"
            }
          }
        },
        "general_settings_updated": "Kiosk instellingen geupdate",
        "menu_title": "Kiosks",
        "create_dialog_title": "Kiosk aanmaken",
        "create_dialog_title_screen": "Scherm-url aanmaken",
        "zone_not_found": "Zone niet gevonden, niet verder met aanmaken",
        "kiosk_deleted": "Kiosk verwijderd",
        "kiosk_delete_title": "Kiosk \"%{name}\" verwijderen",
        "kiosk_created": "Kiosk aangemaakt!",
        "kiosk_created_screen": "Scherm aangemaakt!",
        "zone_warning": "Deze kiosk zal bij opslaan verplaatst worden naar het midden van de geselecteerde zone.",
        "admin_actions": {
          "button": "Admin acties"
        },
        "kiosk_moved": "Kiosk verhuisd!",
        "kiosk_move_title": "Kiosk \"%{name}\" verhuizen",
        "kiosk_regenerated": "Kioskreferenties opnieuw gegenereerd. Oude url niet meer bruikbaar",
        "kiosk_regenerate_button": "Url opnieuw genereren",
        "kiosk_regenerate_title": "Url voor \"%{name}\" opnieuw genereren",
        "customer_admin_create_dialog_content": "De Kiosk is een geweldige manier om te laten zien en te beheren wie er beschikbaar is in uw organisatie.\n\n## Aanwezigheidsdetectie met de BHV-Knop.nl Kiosk\nKiosken zijn vooral gericht op bedrijfshulpverlening.\n\n[Lees meer over aanwezigheidsdetectie](https://bhv-knop.nl/hoe-werkt-het/aanwezigheidsdetectie/)\n\n## Hardware\nWe bieden een volledig beheerde oplossing met onze handige touchscreens. Vooral gericht op onze BHV-Knop.nl-klanten.\n\nNeem contact op met uw accountmanager voor meer informatie.\n\n![Kiosk voorbeeld](https://bhv-knop.nl/wp-content/uploads/2024/02/kiosks-663x1024.png)\n\n## Toon een kiosk op uw eigen bestaande schermen\nWij bieden de mogelijkheid om de kiosk te tonen op uw bestaande bedrijfsschermen. U ontvangt een webbrowser-URL om op het scherm te tonen.\n\nU bezit deze licentie momenteel niet. Neem contact op met uw accountmanager voor meer informatie.",
        "general_settings": {
          "overwrite": "Standaardconfiguratie overschrijven"
        },
        "default_config": "Configureer",
        "kiosk_preview": "Kiosk voorbeeld",
        "create_mode_dialog_title": "Wilt u een nieuwe kiosk of scherm aanmaken?",
        "add_kiosk_subtext": "Voeg een beheerde kiosk toe",
        "status": {
          "online": "Kiosk gezien in de afgelopen 30 minuten.",
          "offline": "Kiosk niet gezien in de afgelopen 30 minuten."
        },
        "none_yet": "Nog geen kiosks",
        "edit_single_confirm_content": "Weet u zeker dat u één kiosk wilt bewerken? U kunt ook de algemene kioskinstellingen voor dit account bewerken.",
        "edit_single_confirm_title": "Weet u zeker dat u één kiosk wilt bewerken?",
        "edit_single_confirm_cancel": "Nee, bewerk de algemene instellingen voor kiosks",
        "edit_single_confirm_confirm": "Ja, ga door met bewerken",
        "publish": "Publiceer naar %{smart_count} kiosk |||| Publiceer naar %{smart_count} kiosks",
        "defaults": "Kiosk-standaarden",
        "menu_title-beta": "Kiosken (bèta)",
        "kiosk_created_but_failed_to_sync_zone_in_client_config": "Kiosk aangemaakt, maar synchronisatie van de zone mislukt."
      }
    },
    "groups": {
      "text": {
        "bhvk-explanation": "Groepen worden gebruikt voor het scheiden van gebruikers in uw organisatie. Zo kunt u bijvoorbeeld een groep aanmaken met BHV'ers en een groep 'Hoofd BHV' of 'AIT (Agressie Interventie Team').BHV-Knoppen kunnen ook worden georganiseerd in groepen. BHV-Knop.nl kan samen met u instellen dat er per groep onderscheid gemaakt kan worden in hoe en wanneer het alarm binnenkomt.",
        "members": "1 lid |||| %{smart_count} leden"
      }
    },
    "auditlogs": {
      "text": {
        "subject": "Onderwerp",
        "user": "Gebruiker",
        "operation": "Actie",
        "title": "Controlelogboeken",
        "resource_types": "Document type",
        "expose_users": "Gebruikers tonen"
      }
    },
    "customer-alarm-center-relations": {
      "title": "Meldkamer relaties",
      "fields": {
        "enabled": "Ingeschakeld",
        "priority": "Prioriteit"
      },
      "name": "Meldkamer relatie"
    },
    "config": {
      "text": {
        "defaults_updated": "Standaardinstellingen voor kiosk bijgewerkt",
        "defaults_update_error": "Fout bij het updaten van standaardinstellingen. Een of meer keys zijn niet geüpdatet",
        "no_access": "Geen toegang"
      }
    },
    "registration-templates": {
      "fields": {
        "profile": {
          "assetGroups": "Asset groepen",
          "legacyConfigGroups": "Legacy-configuratiegroepen",
          "configGroups": "Configuratie groepen",
          "assetGroupLimit": "Beperk tot groepen"
        },
        "numberUsed": "Aantal gebruikt"
      },
      "text": {
        "title": "Registratiesjablonen"
      }
    },
    "legacy-domainlinks": {
      "title": "Domeinrestricties (legacy)"
    },
    "alarm-call-phone-numbers": {
      "fields": {
        "phoneNumber": "Telefoonnummer",
        "type": "Type",
        "numberOfAssetGroupsAndAssets": "Aantal activagroepen/activa",
        "timesCalled": "Tijden genoemd",
        "lastTimeCalled": "Laatst gebeld op"
      },
      "type": {
        "general": "Algemeen",
        "additional": "Aanvullend"
      },
      "lastTimeCalled": {
        "neverCalled": "Nooit"
      },
      "text": {
        "page_info": "Elke telefoonnummervermelding in deze tabel linkt naar de bijbehorende configuratiepagina. Wijzigingen in deze configuraties kunnen van invloed zijn op de alarmrespons en het aanmaken van alarmen.\nU kunt deze pagina gebruiken om de telefoonnummers van een klant te bekijken of aan te passen en, via de bijbehorende actieknoppen, de configuratie ervan te bekijken of te wijzigen.",
        "general_customer_config_button": "Algemene klantconfiguraties",
        "addGeneral": "Voeg een algemeen nummer toe",
        "addAdditional": "Voeg een extra getal toe",
        "add_general_number_button": "Toevoegen",
        "buy_additional_number_button": "Kopen",
        "selectInput": {
          "selectCountry": "Land selecteren",
          "options": {
            "countryID": "Nederland",
            "countryName": "Nederland"
          }
        },
        "successMessage": {
          "addGeneral": "Het algemene telefoonnummer is succesvol toegevoegd",
          "addAdditional": "Het extra telefoonnummer is succesvol toegevoegd"
        },
        "errorMessage": {
          "addGeneral": "Het toevoegen van een algemeen telefoonnummer is mislukt",
          "addAdditional": "Het toevoegen van een extra telefoonnummer is mislukt"
        },
        "generalConfig": {
          "title": "Algemene configuraties",
          "manageCustomer": "Klanten beheren"
        },
        "unlink_customer_button": "Ontkoppel klant"
      },
      "title": "Alarmnummers",
      "create": {
        "title": "Maak een telefoonnummer aan"
      }
    },
    "certification-categories": {
      "title": "Certificeringscategorieën",
      "fields": {
        "validity_period": "Geldigheidsperiode",
        "is_documentary_proof_required": "Vereist bewijsdocumenten",
        "people_to_notify": "Personen om te informeren",
        "custom_reminder_periods": "Aangepaste herinneringsperioden",
        "reminder_periods": "Herinneringsperiodes",
        "certified_user": "Gecertificeerde gebruiker",
        "certified_users": "Gecertificeerde gebruikers"
      },
      "text": {
        "create_title": "Een nieuwe certificeringscategorie aanmaken",
        "category_explanation": "Certificeringscategorieën worden gebruikt om te definiëren welke certificaten de gebruikers in uw organisatie kunnen hebben. U kunt bijvoorbeeld een certificeringscategorie aanmaken voor 'BHV Responder' en vervolgens dit type certificaat toekennen aan de dashboardgebruikers.",
        "certified_users": "gecertificeerde gebruikers",
        "certified_users_dialog_title": "Gecertificeerde gebruikers voor",
        "certified_users_dialog_empty": "Er zijn geen gecertificeerde gebruikers voor deze categorie.",
        "count": "Aantal",
        "expiring": "verlopend",
        "title_single": "Certificeringscategorie",
        "expiring_certifications_dialog_title": "Verlopende certificaten voor",
        "days_until_expiry": "Verloopt morgen |||| %{smart_count} dagen tot vervaldatum",
        "already_expired_for": "Verlopen gisteren |||| Al verlopen voor %{smart_count} dagen",
        "edit_confirmation_dialog_title": "Bewerking bevestigen",
        "edit_confirmation_dialog_content": "Weet je zeker dat je de optie 'bewijsmateriaal niet vereist' wilt instellen? Hiermee worden alle bestaande bewijsstukken voor deze categorie verwijderd.",
        "expires_today": "Verloopt vandaag",
        "add_from_presets_title": "Certificeringscategorieën toevoegen vanuit vooraf ingestelde opties.",
        "add_from_presets_subtitle": "U kunt certificaten uit vooraf ingestelde sjablonen aan uw organisatie toevoegen.",
        "custom_reminder_create": "+ Creëren",
        "custom_reminder_period_title": "Voeg een aangepaste herinneringsperiode toe",
        "no_results": "Geen resultaten gevonden voor uw zoekopdracht.",
        "name_helper": "Bijvoorbeeld \"BHV-certificaat\"",
        "validity_period_helper": "Hoe lang is een certificaat van dit type geldig?",
        "people_to_notify_helper": "Wie moet meldingen ontvangen over het verlopen van certificaten?",
        "reminder_periods_helper": "Hoe lang vóór het verlopen moeten de e-mails worden verzonden? U kunt meerdere opties selecteren",
        "documentary_proof_helper": "Is het verplicht om een scan van het certificaat te uploaden?",
        "filter_by": "Filteren op",
        "expired": "verlopen",
        "valid": "geldig",
        "user_count": "Aantal gebruikers",
        "certified": "gecertificeerd",
        "expiring_certifications_dialog_empty": "Geen verlopende certificaten voor deze categorie",
        "expired_certifications_dialog_empty": "Geen verlopen certificaten voor deze categorie",
        "expired_certifications_dialog_title": "Verlopen certificaten voor",
        "users_dialog_title": "Certificaten voor",
        "users_dialog_empty": "Geen gebruikers gevonden voor deze categorie",
        "add_category_dialog_title": "Certificeringscategorie toevoegen",
        "preset_already_exists": "Er bestaat al een certificeringscategorie met deze naam",
        "people_to_notify_title": "Selecteer de personen die u wilt informeren",
        "certified_users_modal_title": "Beheer certificaten voor de categorie %{category}",
        "certified_users_select_subtitle": "Beheer gebruikers of groepen voor de certificeringscategorie.",
        "certified_users_dates_subtitle": "Vul de gegevens in voor elke gecertificeerde gebruiker.",
        "manage_certificates": "Certificaten beheren",
        "all_users_already_certified": "Alle beschikbare gebruikers zijn reeds gecertificeerd",
        "no_users_added": "Geen gecertificeerde gebruikers toegevoegd",
        "users_added": "1 gebruiker toegevoegd |||| %{smart_count} gebruikers toegevoegd",
        "invalid_recipient_selection": "Ongeldige gebruikersselectie",
        "users_removed": "1 gebruiker verwijderd |||| %{smart_count} gebruikers verwijderd"
      },
      "presets": {
        "basic_emergency_response_officer": {
          "name": "BHV Basis",
          "description": "Basis Bedrijfshulpverlening inclusief EHBO, brandbestrijding en ontruiming."
        },
        "bhv_team_leader": {
          "name": "Ploegleider BHV",
          "description": "Leidinggeven aan BHV-teams tijdens noodsituaties en evacuaties."
        },
        "head_of_emergency_response": {
          "name": "Hoofd BHV",
          "description": "Verantwoordelijk voor BHV-organisatie en coördinatie van noodprocedures."
        },
        "basic_vca": {
          "name": "VCA Basis",
          "description": "Veiligheid, gezondheid en milieu voor operationele medewerkers."
        },
        "vol_vca": {
          "name": "VOL-VCA",
          "description": "VCA-certificaat voor operationeel leidinggevenden."
        },
        "forklift_certificate": {
          "name": "Heftruckcertificaat",
          "description": "Veilig bedienen van heftrucks en intern transportmaterieel."
        },
        "reach_truck_certificate": {
          "name": "Reachtruckcertificaat",
          "description": "Veilig bedienen van reachtrucks in magazijnomgevingen."
        },
        "aerial_work_platform_certificate": {
          "name": "Hoogwerkercertificaat",
          "description": "Veilig werken met hoogwerkers en mobiele werkplatforms."
        },
        "nen_3140_skilled_person": {
          "name": "NEN 3140 VP",
          "description": "Vakbekwaam persoon voor veilig werken aan elektrische installaties."
        },
        "nen_3140_installation_responsible": {
          "name": "NEN 3140 IV",
          "description": "Installatieverantwoordelijke voor elektrische installaties."
        },
        "respiratory_protection": {
          "name": "Adembescherming",
          "description": "Training voor veilig gebruik van adembeschermingsmiddelen."
        },
        "working_at_height": {
          "name": "Werken op hoogte",
          "description": "Veilig werken op hoogte inclusief valbeveiliging."
        },
        "basic_first_aid": {
          "name": "EHBO Basis",
          "description": "Basisopleiding Eerste Hulp Bij Ongelukken."
        },
        "pediatric_first_aid": {
          "name": "EHBO Kinderen",
          "description": "Eerste hulpverlening gericht op baby's en kinderen."
        },
        "sports_first_aid": {
          "name": "EHBO Sport",
          "description": "EHBO gericht op sportblessures en acute zorg tijdens sportactiviteiten."
        },
        "first_aid_refresher": {
          "name": "EHBO Herhaling",
          "description": "Jaarlijkse herhalingstraining voor EHBO-certificaat."
        },
        "cpr_aed": {
          "name": "AED / Reanimatie",
          "description": "Training in reanimatie en gebruik van een AED."
        },
        "text": {
          "search": "Voorinstellingen doorzoeken..."
        }
      }
    },
    "security-inventory-categories": {
      "title": "Beveiligingsinventariscategorieën",
      "text": {
        "sub_title": "Beveiligingsgerelateerde inventaris omvat items die essentieel zijn voor het waarborgen van de veiligheid van mensen binnen uw organisatie.\n\nU kunt categorieën van deze items beheren in de onderstaande tabel.",
        "settings_sub_title": "Je kunt de categorie-instellingen hieronder bewerken. Zorg ervoor dat je alle verplichte velden invult.",
        "title_single": "Beveiligingsinventariscategorie",
        "select_icon": "Selecteer een icon",
        "add_from_presets_title": "Voeg een inventariscategorie toe vanuit de voorinstellingen.",
        "add_from_presets_subtitle": "Hieronder vindt u de voorinstellingen voor voorraadcategorieën. Selecteer een voorinstelling om deze toe te voegen aan de lijst met voorraadcategorieën die beschikbaar zijn in uw organisatie.",
        "select_category": "Selecteer categorie",
        "settings_button": "Categorie-instellingen",
        "create_title": "Maak een nieuwe artikelcategorie aan",
        "category_explanation": "Je kunt hier een aangepaste artikelcategorie toevoegen als deze categorie niet beschikbaar is in de voorinstellingen.",
        "no_results": "Geen resultaten voor je zoekopdracht",
        "name_helper": "Bijvoorbeeld \"Brandblussers\"",
        "people_to_notify_helper": "Wie moet meldingen ontvangen over het verlopen van items?",
        "reminder_periods_helper": "Hoe lang vóór het verlopen moeten de e-mails worden verzonden? U kunt meerdere opties selecteren",
        "inspection_period_helper": "Hoe lang is een item van dit type geldig voordat het opnieuw geïnspecteerd moet worden?",
        "add_category_dialog_title": "Inventariscategorie toevoegen",
        "preset_already_exists": "Er bestaat al een beveiligingsinventariscategorie met deze naam",
        "people_to_notify_title": "Selecteer de personen die u wilt informeren"
      },
      "fields": {
        "inspection_period": "Inspectieperiode",
        "people_to_notify": "Personen om te informeren",
        "icon": "Icon",
        "items_count": "Aantal artikelen"
      },
      "presets": {
        "text": {
          "search": "Zoek voorinstellingen..."
        }
      }
    },
    "customer_access_request": {
      "title": "Toegang tot klant aanvragen",
      "fields": {
        "customer": "Klant",
        "duration": "Duur van de toegang",
        "reason": "Reden voor toegang",
        "force": "Verzoek forceren",
        "role_preview": "Aangevraagde rol"
      },
      "options": {
        "duration_1_day": "1 dag",
        "duration_2_days": "2 dagen",
        "duration_1_week": "1 week",
        "duration_2_weeks": "2 weken"
      },
      "validation": {
        "customer_required": "Selecteer een klant",
        "reason_min_length": "De reden moet minimaal 10 tekens bevatten",
        "force_short_duration_only": "Geforceerde aanvragen zijn alleen toegestaan voor 1 of 2 dagen",
        "no_global_role": "Uw account mist een globale sales- of supportrol voor dit verzoek"
      },
      "notifications": {
        "submit_success": "Toegangsaanvraag verzonden",
        "request_granted": "Uw toegangsaanvraag is goedgekeurd.",
        "request_denied": "Uw toegangsaanvraag is afgewezen.",
        "already_pending": "U hebt al een openstaande toegangsaanvraag voor deze klant."
      },
      "text": {
        "redirected_from_customer_switch": "U hebt nog geen toegang tot deze klant. Dien een aanvraag in om verder te gaan.",
        "already_pending": "U hebt al een openstaande toegangsaanvraag voor deze klant. U krijgt een melding wanneer deze is beoordeeld.",
        "open_request_locked_with_force": "U hebt al een openstaand toegangsverzoek voor deze klant. De onderstaande gegevens kunnen niet worden gewijzigd. Schakel 'Geforceerd toegang verkrijgen' in om direct toegang te verkrijgen. Beheerders worden op de hoogte gesteld van deze actie.",
        "requesting_for_customer": "Toegang aanvragen voor %{customer}"
      },
      "actions": {
        "submit": "Aanvraag indienen"
      }
    },
    "customer_access_review": {
      "title": "Beoordeling toegangsaanvragen",
      "fields": {
        "customer": "Klant",
        "requested_by": "Aangevraagd door (gebruikers-id)",
        "requested_role": "Aangevraagde rollen",
        "valid_until": "Geldig tot",
        "reason": "Reden",
        "force_requested": "Geforceerd verzoek",
        "status": "Status",
        "column_actions": "Acties"
      },
      "status": {
        "open": "Open",
        "approved": "Goedgekeurd",
        "rejected": "Afgewezen"
      },
      "actions": {
        "reload": "Vernieuwen",
        "approve": "Goedkeuren",
        "reject": "Afwijzen",
        "reject_reason": "Reden voor afwijzing"
      },
      "validation": {
        "reject_reason_min_length": "De reden voor afwijzing moet minimaal 10 tekens bevatten"
      },
      "text": {
        "cannot_review_own_request": "U kunt uw eigen toegangsaanvraag niet beoordelen",
        "loading": "Bezig met laden…",
        "empty": "Geen toegangsaanvragen gevonden"
      },
      "forced": {
        "yes": "Ja",
        "no": "Nee"
      },
      "notifications": {
        "load_error": "Laden van toegangsaanvragen mislukt",
        "approve_success": "Aanvraag goedgekeurd",
        "reject_success": "Aanvraag afgewezen"
      },
      "switch": {
        "show_all": "Laat alle aanvragen zien"
      }
    },
    "security-inventory-items": {
      "text": {
        "search": "Zoek naar items...",
        "no_results": "Geen artikelen gevonden",
        "place_item": "Plaats item",
        "item_lowercase": "item",
        "delete_dialog_title": "Verwijder items",
        "delete_content": "Weet je zeker dat je deze items wilt verwijderen?",
        "how_many_items": "Hoeveel artikelen wilt u toevoegen?",
        "expiry_date_input_helper_text": "De vervaldatum wordt standaard ingevuld op basis van de laatst ontvangen datum plus de vervaldatum van de betreffende artikelcategorie. U kunt deze indien nodig handmatig wijzigen.",
        "all_categories": "Alle categorieën",
        "categories_chosen": "Categorieën geselecteerd",
        "filter_category": "Categorie",
        "renew_now_modal_title": "Nu verlengen",
        "renew_now_modal_helper_text": "De vervaldatum wordt vooringevuld op basis van de laatste inspectiedatum plus de vervalinterval van de itemcategorie. U kunt deze indien nodig handmatig aanpassen.",
        "plan_renewal_modal_title": "Verlenging plannen",
        "add_planned_renewal_date": "Verlenging plannen op een datum",
        "remove_planned_renewal_date": "Geplande datum verwijderen",
        "manage_inspection": "Inspectie beheren",
        "choice_dialog_title": "Inspectie beheren",
        "plan_inspection": "Inspectie plannen",
        "not_planned_yet": "Nog niet gepland",
        "remove_planned_inspection_date": "Geplande inspectiedatum verwijderen",
        "confirm_move_marker_title": "Item op kaart verplaatsen?",
        "confirm_move_marker_content": "De locatie is gewijzigd. Wilt u dit item op de kaart verplaatsen naar de nieuwe locatie?",
        "expiry_date_manual_edit_helper_text": "U kunt dit handmatig bewerken",
        "item": "1 item |||| %{smart_count} items",
        "planned_inspection_date_helper_text": "E-mailmeldingen worden uitgesteld tot de geplande inspectiedatum.",
        "show_items_responsible": "Alleen items tonen waarvoor ik verantwoordelijk ben",
        "show_all_categories": "Toon alle inventariscategorieën",
        "edit_item_title": "Bewerk %{inventoryCategory}-item",
        "add_item_dialog": "Waar wilt u dit %{categoryName}-artikel plaatsen?",
        "renew_now": "Inventarisitem al geïnspecteerd",
        "choice_dialog_subtitle": "Hoe wilt u de geselecteerde inventarisitems bijwerken?",
        "renew_now_subtitle": "Stel nieuwe inspectie- en vervaldatums in voor de geselecteerde inventarisitems",
        "plan_renewal": "Inventarisitem wordt in de toekomst geïnspecteerd",
        "plan_renewal_subtitle": "Plan wanneer de geselecteerde inventarisitems geïnspecteerd moeten worden",
        "other_inventory_items": "Overige inventaris (%{count})",
        "items_i_am_responsible_for": "Inventaris waarvoor ik verantwoordelijk ben (%{count})",
        "number_of_expiring": "Totaal aantal verlopende inventarisitems",
        "number_of_expired": "Totaal aantal verlopen inventarisitems"
      },
      "fields": {
        "last_inspection_date": "Laatste inspectiedatum",
        "expiry_date": "Vervaldatum",
        "planned_renewal_date": "Geplande verlengingsdatum",
        "planned_inspection_date": "Geplande inspectiedatum",
        "identifier_placeholder": "id12345",
        "identifier": "Identificatiecode"
      },
      "validation": {
        "expiry_date_must_be_future": "De vervaldatum moet in de toekomst liggen."
      },
      "presets": {
        "fire_extinguishers": {
          "name": "Brandblussers",
          "description": "Draagbare blusmiddelen; jaarlijkse controle door gecertificeerd bedrijf."
        },
        "fire_doors": {
          "name": "Branddeuren",
          "description": "Controle op zelfsluitendheid, afdichting en vrijloop."
        },
        "fire_dampers_ventilation": {
          "name": "Brandkleppen (ventilatie)",
          "description": "Voorkomen van brandoverslag via luchtkanalen; testen op correcte sluiting."
        },
        "fire_alarm_system": {
          "name": "Brandmeldinstallatie",
          "description": "Detectie- en alarmeringssysteem; onderhoud door deskundige partij."
        },
        "fire_hose_reels": {
          "name": "Brandslanghaspels",
          "description": "Controle op waterdruk, slangconditie en correcte werking."
        },
        "emergency_lighting": {
          "name": "Noodverlichting",
          "description": "Verlichting bij stroomuitval; controle op batterij en minimale brandduur."
        },
        "evacuation_alarm_system": {
          "name": "Ontruimingsalarminstallatie",
          "description": "Alarmering voor evacuatie; controle op werking en verstaanbaarheid."
        },
        "smoke_detectors": {
          "name": "Rookmelders",
          "description": "Rookmelders voor vroegtijdige branddetectie; controle op werking en vervuiling."
        },
        "sprinkler_system": {
          "name": "Sprinklerinstallatie",
          "description": "Automatisch blussysteem; controle op werking en installatie."
        },
        "escape_route_signage": {
          "name": "Vluchtwegaanduiding",
          "description": "Controle op zichtbaarheid en actualiteit."
        },
        "aed_automated_external_defibrillator": {
          "name": "AED (Automatische Externe Defibrillator)",
          "description": "Controle op batterij, elektroden en statusindicator."
        },
        "first_aid_kits": {
          "name": "EHBO-koffers",
          "description": "Controle op inhoud, houdbaarheidsdata en aanvulling van materialen."
        },
        "co2_carbon_monoxide_detectors": {
          "name": "CO₂ / Koolmonoxidemelders",
          "description": "Detecteren gevaarlijke concentraties CO; controle op werking en sensorbetrouwbaarheid."
        },
        "gas_detection_systems": {
          "name": "Gasdetectiesystemen",
          "description": "Detectie van gevaarlijke gassen; controle op nauwkeurigheid en alarm."
        },
        "evacuation_plans": {
          "name": "Ontruimingsplannen",
          "description": "Controle op actualiteit van vluchtroutes en verzamelplaatsen."
        },
        "ppe_personal_protective_equipment": {
          "name": "PBM (Persoonlijke Beschermingsmiddelen)",
          "description": "Inspectie op slijtage, beschadiging en conformiteit met normen."
        },
        "eyewash_station": {
          "name": "Oogdouche",
          "description": "Spoelen, controleren op lekkage"
        },
        "emergency_shower": {
          "name": "Nooddouche",
          "description": "Spoelen, controleren op lekkage"
        }
      }
    },
    "expiry_date_display": {
      "text": {
        "click_to_reset_expiry": "Klik om de vervaldatum terug te zetten naar de vooraf berekende waarde."
      }
    },
    "notified-people": {
      "text": {
        "add_email": "+ E-mail toevoegen",
        "add_email_title": "E-mailadres toevoegen",
        "invalid_email": "Voer een geldig e-mailadres in"
      },
      "fields": {
        "email": "E-mailadres"
      }
    }
  },
  "general": {
    "text": {
      "open_in_am": "Alarm Manager",
      "app_mode": {
        "on": "Aan",
        "off": "Uit",
        "risk": "Risico"
      },
      "profile": "Profiel",
      "true": "Waar",
      "false": "Onwaar",
      "move_users_failed": "Niet alle gebruikers zijn succesvol verhuisd.",
      "move_users_success": "Alle gebruikers zijn succesvol verhuisd.",
      "move_users_title": "Verhuis gebruikers",
      "move_users_explanation": "Verhuis gebruikers naar een andere klant",
      "move": "Verhuis",
      "close": "Sluiten",
      "deleted": "verwijderd",
      "none": "geen",
      "all": "Alle",
      "yes": "Ja",
      "no": "Nee",
      "invalid": "Ongeldig",
      "saved": "Opgeslagen",
      "updated": "bijgewerkt",
      "stability": {
        "unstable": "Onstabiel - Gebruik deze pagina niet zonder goede training",
        "beta": "Beta - Deze pagina is vrij te gebruiken maar er kunnen problemen voordoen",
        "stable": "Stabiel - Deze pagina is getest en zou moeten werken zoals verwacht",
        "annotations_title": "Deze pagina heeft de volgende annotaties:"
      },
      "my_user_settings": "Mijn gebruikers-instellingen",
      "never": "nooit",
      "actions": "Acties",
      "contact_info": "Contactinformatie",
      "hover_to_view": "bekijken",
      "export_selection": "Exporteer selectie",
      "export_started": "Export gestart, even geduld a.u.b....",
      "exporting": "Aan het exporteren...",
      "export_all": "Exporteer alles",
      "not_acknowledged": "Niet afgemeld",
      "show_persons": "Bekijk %{length} personen",
      "copied": "Gekopieerd naar het klembord",
      "copy": "Kopieer",
      "proceed": "Doorgaan",
      "mobileWarning": "Helaas is dit dashboard nog niet geschikt voor mobiele apparaten zoals een smartphone. We doen ons best om deze tools ook beschikbaar te maken op uw mobiele telefoon. We raden aan om deze pagina te openen via een PC of tablet.",
      "appUserWarning": "Dit dashboard is alleen beschikbaar voor beheerders in uw organisatie.\n\nU bent nu ingelogd met een X-Guard Alarm-app account. Het is niet mogelijk het dashboard als appgebruiker te bekijken.\nAls u toegang heeft tot ons andere dashboard kunt u onderaan op de knop drukken om daar heen verwezen te worden.",
      "message": "Bericht",
      "replace": "Vervangen",
      "append": "Toevoegen",
      "skip": "Hou huidige waarde",
      "no_template_selected": "Geen sjabloon geselecteerd",
      "no_values": "Geen waarden",
      "no_time_yet": "(Nog) geen tijd",
      "alarm": "Alarm",
      "more_settings": "Meer instellingen",
      "order": "Bestellen",
      "orders": "Bestelgeschiedenis",
      "help": "Help",
      "invoices": "Facturen",
      "none_yet": "Nog geen %{name}, maak er een",
      "settings": "instellingen",
      "install_app": "Installeer de app",
      "when": "Wanneer?",
      "how_often": "Hoe vaak?",
      "gateway": "Basisstation",
      "button": "Knop",
      "appUserWarning_bhvk": "Dit dashboard is alleen beschikbaar voor beheerders in uw organisatie.\n\nU bent nu ingelogd met een account zonder toegang tot dit dashboard. Het is niet mogelijk het dashboard te bekijken met dit account.\nAls u toegang heeft tot ons andere dashboard kunt u onderaan op de knop drukken om daar heen verwezen te worden.",
      "number_unknown": "nummer onbekend",
      "change_username_modal_title": "Welkom in het BHV-Knop.nl Dashboard",
      "current_username": "We hebben automatisch een gebruikersnaam voor u aangemaakt, deze kunt u hier wijzigen",
      "continue": "doorgaan",
      "current": "Huidig",
      "not_in": "Niet in",
      "test": "Testen",
      "send": "Verstuur",
      "persons": "Personen",
      "current_user": "Huidige gebruiker",
      "this_dashboard": "Dit dashboard",
      "enabled": "Ingeschakeld",
      "disabled": "Uitgeschakeld",
      "or": "of",
      "cannot_save": "Opslaan niet mogelijk",
      "no_changes": "Geen veranderingen",
      "theme": "Thema",
      "export_select_columns": "Selecteer kolommen",
      "toggle_all": "Alles selecteren",
      "logo": "Logo URL",
      "filter": "Filteren",
      "location": "Locatie",
      "search_google_maps": "Zoeken via Google Maps",
      "saving": "Opslaan...",
      "order_extra": "Bijbestellen",
      "solve_issues": "Los problemen op",
      "welcome": "Welkom",
      "gateways": "Basisstations",
      "order_singular": "Bestel",
      "online": "Online",
      "last_days": "laatste %{count} dagen",
      "incorrect_phonenumber": "Incorrect telefoonnummer, probeer opnieuw",
      "free_trial": "Gratis testen",
      "licence_active": "Licentie actief",
      "simulate_customer_admin": "Simuleer Klant admin",
      "exit_role_simulation": "Sluit rol simulatie",
      "upload_file": "Upload bestand",
      "emergency_button": "BHV-Knop",
      "select_all": "Selecteer alle",
      "deselect_all": "Deselecteer alle",
      "order_now": "Bestel nu",
      "emergency_buttons": "BHV-Knoppen",
      "filtered": "Gefilterd",
      "go_to_management": "Ga naar Beheerdashboard",
      "go_to_bhvk": "Ga naar Beheer.BHV-Knop",
      "form": {
        "inherit": "Erf",
        "override": "Overschrijf"
      },
      "map_floors": "Bouwlaag",
      "device": "Apparaat",
      "search_location": "Zoek locatie",
      "availability": "Aanwezigheid",
      "from": "Van",
      "until": "Tot",
      "optional": "optioneel",
      "general": "Algemeen",
      "invalid_time": "Moet een geldige tijd zijn",
      "time_end_before_start": "Eindtijd moet na starttijd zijn",
      "timestamp": "Tijdstempel",
      "history": "Geschiedenis",
      "seconds": "seconden",
      "person": "persoon |||| personen",
      "customer_not_found": "Geen klant gevonden met opgegeven ID",
      "present": "Aanwezig",
      "overwrite": "Overschrijven",
      "add": "Toevoegen",
      "remove": "Verwijderen",
      "buttons_or_persons": "Knoppen of personen",
      "add_from_presets": "Toevoegen vanuit voorinstellingen",
      "edit": "Bewerking",
      "loading": "Laden",
      "loading_secondary": "Even geduld alstublieft",
      "items": "Artikelen",
      "confirm": "Bevestigen",
      "days": "dagen",
      "time_granularity_types": {
        "day": "1 dag |||| %{smart_count} dagen",
        "week": "1 week |||| %{smart_count} weken",
        "month": "1 maand |||| %{smart_count} maanden",
        "quarter": "1 kwartaal |||| %{smart_count} kwartalen",
        "year": "1 jaar |||| %{smart_count} jaar"
      },
      "add_email": "+ E-mail toevoegen",
      "add_email_title": "E-mailadres toevoegen",
      "invalid_email": "Voer een geldig e-mailadres in",
      "add_custom_category": "Aangepaste categorie toevoegen",
      "add_custom_category_subtitle": "Voeg een aangepaste categorie toe en configureer alle instellingen handmatig",
      "add_from_presets_subtitle": "Selecteer een of meerdere vooraf geconfigureerde categorieën",
      "clear": "Wissen",
      "next": "Volgende",
      "email_will_not_be_sent": "Er wordt geen e-mail verzonden omdat er geen verantwoordelijke personen zijn toegewezen.",
      "will_receive": "is verantwoordelijk voor %{categoryName}. |||| zijn verantwoordelijk voor %{categoryName}.",
      "users": "%{count} gebruikers",
      "email_will_be_sent": "De volgende e-mail wordt morgen verzonden. |||| De volgende e-mail wordt over %{smart_count} dagen verzonden.",
      "will_be_sent_today": "De volgende e-mail wordt vandaag verzonden.",
      "will_not_be_sent_item_expired": "Er wordt geen e-mail verzonden. Het artikel is gisteren verlopen. |||| Er wordt geen e-mail verzonden. Het artikel is %{smart_count} dagen geleden verlopen.",
      "will_not_be_sent_certification_expired": "Er wordt geen e-mail verzonden. Certificaat is gisteren verlopen. |||| Er wordt geen e-mail verzonden. Certificaat is %{smart_count} dagen geleden verlopen.",
      "responsible_users": "Verantwoordelijke gebruiker: |||| Verantwoordelijke gebruikers:",
      "certified_users": "Gecertificeerde gebruiker:"
    },
    "fields": {
      "createdAt": "Aangemaakt op",
      "updatedAt": "Bijgewerkt op",
      "position": {
        "address": {
          "countrycode": "Land code",
          "state": "Staat",
          "city": "Stad",
          "streetName": "Straatnaam",
          "streetNumber": "Straat nummer",
          "floor": "Verdieping",
          "formattedAddress": "Opgeslagen geformatteerde adres",
          "name": "Adres"
        },
        "latitude": "Breedtegraad",
        "longitude": "Lengtegraad",
        "coordinates": "Coördinaten",
        "name": "Positie",
        "properties": {
          "dateTime": "Datum en tijd van positie"
        }
      },
      "name": "Naam",
      "description": "Beschrijving",
      "person_or_object": "Persoon of object",
      "madeBy": "Gemaakt door",
      "number": "Nummer",
      "registration_profile": "Registratieprofiel",
      "email": "E-mailadres"
    },
    "errors": {
      "username_too_short": "Gebruikersnaam moet minstens 3 tekens lang zijn."
    }
  },
  "pages": {
    "live_map": {
      "text": {
        "no_assets_in_customer": "Geen personen of objecten gevonden",
        "position_is": "Positie is ",
        "indoors": "binnen ",
        "outdoors": "buiten ",
        "at": " op",
        "accuracy": "Nauwkeurigheid is %{accuracy} meter",
        "last_position": "Laatste positie was %{time}",
        "person_available": "Deze persoon is %{available} beschikbaar",
        "not": "niet",
        "app_mode": "App mode is"
      }
    },
    "userReceiverInitialisation": {
      "title": "Hoe wilt u Alarmen ontvangen?"
    }
  },
  "menu": {
    "items": {
      "live": "Live",
      "map": "Kaart",
      "my_organisation": "Mijn organisatie",
      "alarms": "Alarmen",
      "create_alarm": "Maak alarm",
      "access": "Toegang",
      "root_admins": "Root beheerders",
      "problematic_alarms": "Problematische alarmen",
      "alarm_app": "X-Guard Alarm App",
      "groups": "Groepen",
      "qr_codes": "QR Codes",
      "people_assets": "Personen & Assets",
      "assets": "Assets",
      "tags": "Tags",
      "flic": "Flic",
      "alarm_tasks": "Alarm Taken",
      "resources": "Bronnen",
      "alarm_handling": "Alarm afhandeling",
      "reports": "Rapportages",
      "manage": "Beheer",
      "users": "Gebruikers",
      "management_users": "Gebruikers",
      "dashboard": "Dashboard",
      "maps": "Kaarten",
      "response": "Controleer opvolging",
      "app-defaults": "App standaarden",
      "certifications": "Certificaten",
      "security_inventory": "Beveiligingsinventaris",
      "customer_access_request": "Toegang aanvragen",
      "customer_access_review": "Toegangsaanvragen"
    },
    "text": {
      "brought_by": "Aangeboden door"
    }
  },
  "home": {
    "text": {
      "title": "Welkom bij het X-Guard Managment dashboard",
      "description": "U kunt dit dashboard gebruiken voor het bekijken van uw huidige X-Guard-omgeving. Momenteel is het nog niet mogelijk om aanpassingen te maken, deze mogelijkheden worden later toegevoegd.",
      "block_one": "### Welkom bij het X-Guard Management dashboard\n\nU kunt dit dashboard gebruiken voor het beheren en bekijken van uw huidige X-Guard-omgeving.",
      "block_two": "#### Update 1.21\nVanaf nu kunt u aanwezigheid monitoren voor al uw zones. In één oogopslag zien hoeveel personen er beschikbaar zijn voor alarmopvolging is nu erg gemakkelijk.\n\nDaarnaast is het mogelijk om een e-mail te ontvangen als het ingestelde doel niet wordt gehaald.\n\n#### Update 1.20\nVanaf deze versie is het mogelijk om plattegronden toe te voegen. Plattegronden zijn zichtbaar op alle pagina's met een kaart in dit dashboard en op BHV-Knop.nl-kioskschermen in uw organisatie. Plattegronden worden tevens gebruikt door centralisten om nauwkeuriger binnen een pand te lokaliseren.\n\nDaarnaast worden er nu onder het kopje 'Live' verschillende rapportages toegevoegd waarmee u direct de huidige status van uw organisatie kunt monitoren.\n\n#### Update 1.19\nDeze versie betrof een grotere stabiliteitsupdate.\n\n#### Update 1.18\nHet is nu mogelijk om rapportage te beheren, direct vanuit dit dashboard. Pas aan of rapportage verstuurd wordt en naar wie.\n\n#### Update 1.17\n\nVanaf versie 1.17 heeft u nu toegang tot de Zone-configuratiepagina. Deze pagina geeft u inzicht in hoe bepaalde zones binnen het X-Guard systeem zijn gedefinieerd.\n\nU kunt zones bewerken, toevoegen en verwijderen. Het toevoegen van geavanceerde configuratie aan een zone wordt echter nog steeds gedaan door het X-Guard-ondersteuningsteam. Voor uw veiligheid is het niet mogelijk een zone te verwijderen waaraan een geavanceerde configuratie is gekoppeld.\n\nWeet u niet zeker waar u moet beginnen? Neem contact op met uw X-Guard Accountmanager voor een korte uitleg.\n\n\n#### Update 1.16\n\nHet is nu mogelijk om app-gebruikers rechtstreeks vanuit het dashboard **toe te voegen, te verwijderen en te bewerken**. Daarnaast kunt u **groepen beheren** en **gebruikers beheren**.\n\nAppgebruikers zijn gebruikers die gebruik kunnen maken van de X-Guard Alarm-app. Zij kunnen het Management Dashboard en Alarm Manager niet gebruiken.\n\nGebruikers hebben toegang tot het Management Dashboard en de Alarm Manager en kunnen administratieve taken uitvoeren.",
      "block_three": "#### Feedback\n\nKomt u iets tegen in dit dashboard wat niet klopt of niet op de juiste manier werkt? Of heeft u een wens?\n\n**Rechtsonder op alle pagina's** van het Management Dashboard vindt de **Feedback-knop**. Gebruik deze om direct feedback over dit dashboard door te geven aan het X-Guard Ontwikkelteam."
    }
  },
  "ra": {
    "message": {
      "clear_array_input": "Weet u zeker dat u de hele lijst wilt legen?"
    },
    "input": {
      "image": {
        "remove_current": "Huidige verwijderen"
      }
    },
    "action": {
      "preview": "Voorbeeld",
      "publish": "Publiceren",
      "manage_renewal": "Verlenging beheren"
    },
    "notification": {
      "name_too_long": "Naam te lang"
    }
  },
  "qr-templates": {
    "text": {
      "page_info": "U gebruikt een QR-code om direct vanuit de X-Guard Alarm-app te registreren in uw organisatie.\n\nDeel de QR-codes met personen die zich moeten aanmelden binnen de app."
    }
  },
  " resources": {
    "report-triggers": {
      "text": {
        "config_types": {
          "unhealthyBeacons": "Ongezonde bakens"
        }
      }
    }
  },
  "resource": {
    "customers": {
      "fields": {
        "hasKioskConfig": "Heeft kiosk configuratie"
      }
    },
    "buttons": {
      "automove_subtitle": "We kunnen deze knop automatisch verplaatsen naar het nieuwe adres. Wilt u de knop verplaatsen?",
      "automove_no": "Nee, behoud huidige plek",
      "automove_yes": "Ja, verplaats automatisch naar nieuwe adres"
    }
  },
  "homepage": {
    "text": {
      "welcome_text2": "op uw BHV-Knop.nl dashboard",
      "welcome_subtext": "Via dit dashboard kunt u de instellingen voor uw BHV-Knop.nl-account wijzigen. Upload een plattegrond, plaats uw BHV-Knopen op de juiste plek en nodig BHV'ers uit.",
      "actual_status": "Actuele status van uw systeem",
      "show_gateways": "Bekijk basisstations",
      "continue_setting_up": "Ga verder met het instellen van uw account",
      "continue_setting_up_subtext": "Alvorens u een alarm kan maken, moet u eerst uw telefoonnummer opgeven. Dit is nodig om u te kunnen bellen bij een alarm. Het is ook mogelijk om een alarm te ontvangen via onze app."
    }
  },
  "ra-audit-log": {
    "inline_event": {
      "read": "Lezen"
    }
  },
  "notifications": {
    "customer_access_request_browser": {
      "title": "Klanttoegangsverzoek",
      "body_fallback": "Er staat een nieuw klanttoegangsverzoek open.",
      "customer_id_prefix": "Klant ",
      "user_id_prefix": "Gebruiker "
    }
  },
  "clientConfig": {
    "menu": {
      "manager": "ClientConfig Beheer",
      "groups": "ClientConfig Groepen"
    },
    "buttons": {
      "openManager": "Open ClientConfig Beheer"
    },
    "manager": {
      "title": "ClientConfig Beheer",
      "customer": "Klant",
      "group": "Groep",
      "device": "Apparaat",
      "assignedGroups": "ClientConfig Groepen",
      "selectGroups": "Selecteer groepen",
      "changedKeys": "Gewijzigde sleutels t.o.v. standaard",
      "baseline": {
        "settings": "Basislijninstellingen",
        "selectLabel": "Vergelijk met standaard",
        "mode": {
          "allCustomers": "Alle klanten (globaal)",
          "thisCustomer": "Deze klant",
          "thisGroup": "Deze groep",
          "thisDevice": "Dit apparaat"
        },
        "customerUnavailable": "Kon de klant voor dit item niet bepalen.",
        "groupUnavailable": "Groepsbasislijn is alleen beschikbaar tijdens het bewerken van een groep.",
        "deviceUnavailable": "Apparaatbasislijn is alleen beschikbaar tijdens het bewerken van een apparaat."
      },
      "resetInlineKey": "Instelling resetten",
      "restoreInlineKey": "Instelling herstellen",
      "unsavedChanges": {
        "title": "Niet-opgeslagen wijzigingen",
        "message": "U heeft niet-opgeslagen groeps- of sleutelwijzigingen. Sla deze op voordat u deze pagina verlaat.",
        "save": "Opslaan",
        "stay": "Op pagina blijven"
      }
    },
    "groups": {
      "form": {
        "groups": "ClientConfig Groepen",
        "keys": "ClientConfig Sleutels",
        "key": "Sleutel",
        "editable": "Bewerkbaar",
        "editableBy": "Bewerkbaar door",
        "customerSpecific": "Klant specifieke groep"
      },
      "preview": {
        "title": "ClientConfig Voorvertoning",
        "noChanges": "Geen wijzigingen ten opzichte van standaard.",
        "inlineKey": "Niet door groep bepaald",
        "description": "Bekijk hoe het toevoegen of verwijderen van groepen en sleutels de resulterende clientconfiguratie beïnvloedt."
      },
      "list": {
        "showGlobalGroups": "Toon globale ClientConfig-groepen"
      }
    },
    "preview": {
      "chip": {
        "new": "Nieuw",
        "changed": "Gewijzigd",
        "removedByGroup": "wordt verwijderd door groepswijziging",
        "editedByOtherGroup": "Bewerkt door andere groep",
        "removedInlineKey": "Instelling wordt verwijderd"
      }
    },
    "osFilter": {
      "ios": "iOS",
      "overridesTitle": "OS-specifieke override",
      "addOverride": "OS-override toevoegen",
      "android": "Android",
      "allDevices": "Alle apparaten",
      "osType": "Besturingssysteem",
      "osVersionRange": "OS-versiebereik",
      "targetFilterHelp": "Geldt alleen voor dit configuratieblok.",
      "duplicateOsType": "Er bestaat al een override voor dit besturingssysteem en versiebereik.",
      "osVersionRangeHelp": "Optionele semver, bijv. >=12.0.0",
      "enabled": "Beperken tot specifiek besturingssysteem"
    }
  }
} as const

export default language